import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DirectQuoteAssistService } from '../../services/direct.quote.assist.service';
import { QuoteAssistService } from '../../services/quote.assist.service';
import {
  QuoteAssist, ToolingModel, MaterialsModel, quoteAttributesSection, ManufacturingProcessModel,
  AdditionalRequirementsModel,
  OverheadModel,
  OtherCostModel,
  DirectQuoteAssistModel,
  DirectQuoteAssistProperties
} from './direct-quote-assist.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DirectRfq, MetaDataApiResponse, RfqPart, PartQtyModel, ExtractedRfqLLM } from './direct.rfq.model';
import { Observable, retry, catchError, finalize, timer, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { NumericInputDirective } from '../directives/numeric-input.directive';
import { FormatDecimalDirective } from '../directives/format.decimal.directive';
import { FormatNumberPipe } from '../pipes/format.number.pipe';
import { OnlyPositiveNumbersDirective } from '../shared/only.positive.numbers.directive';
import { QuoteStatus, TrackingModule, TrackingEvents, MixPanelEvents } from '../shared/enums';
import { DirectQuoteBaseComponent } from '../direct.quote.base.component';
import { NumericDecimalDirective } from '../directives/numeric-decimal.directive';
import { FileType } from '../rfq-intake/steps/add-parts/add-parts.component';
import { PhoneFormatDirective } from '../shared/directives/phone-format.directive';
import { RfqNameService } from '../services/rfq-name.service';

@Component({
  selector: 'app-direct-quote-assist',
  imports: [
    NgIf, 
    NgFor, 
    NgClass, 
    FormsModule, 
    NumericInputDirective, 
    FormatDecimalDirective, 
    FormatNumberPipe, 
    OnlyPositiveNumbersDirective, 
    NumericDecimalDirective,
    PhoneFormatDirective
  ],
  templateUrl: './direct-quote-assist.component.html',
  styleUrl: './direct-quote-assist.component.scss'
})
export class DirectQuoteAssistComponent extends DirectQuoteBaseComponent implements OnInit, OnDestroy {
  inputQty: string = '';
  today: string;
  // Add the new flag property
  manufacturingProcessError: boolean = false;
  manufacturingProcessNameError: boolean = false;
  manufacturingProcessCycleTimeError: boolean = false;
  manufacturingProcessTotalLaborTimeError: boolean = false;
  manufacturingProcessTotalMachineTimeError: boolean = false;
  // Add AMR error flags
  amrError: boolean = false;
  amrProcessNameError: boolean = false;
  amrEstimatedCostError: boolean = false;
  // Add Overhead error flag
  overheadError: boolean = false;
  overheadTitleError: boolean = false;
  overheadEstimatedCostError: boolean = false;
  // Add Other Costs error flags
  otherCostsError: boolean = false;
  otherCostsProcessNameError: boolean = false;
  otherCostsEstimatedCostError: boolean = false;

  queryParams = {
    rfqId: '',
    companyId: 0,
    rfqPartId: 0,
    contactId: 0,
    integration: '',
    isTrackingEnabled: 'false'
  }
  tempSummaryPartQtyModel: PartQtyModel[] = [];
  quoteGrandTotal: number = 0;
  isDataLoaded: boolean = true;
  retryCount: number = 10;
  // currentPart!: RfqPart;
  currentPartQty!: PartQtyModel;
  partRangeText!: string | null;
  showHeaderLogo: boolean = true;
  profitMargin: number = 0;

  manufacturingBlankSection: ManufacturingProcessModel = this.initializeBlankManufacturingSection();
  blankToolingSection: ToolingModel = this.initializeBlankToolingSection();
  blankAMRSection: AdditionalRequirementsModel = this.initializeBlankAMRSection();
  blankOverheadSection: OverheadModel = this.initializeBlankOverheadSection();
  blankOtherSection: OtherCostModel = this.initializeBlankOtherSection();

  quoteAttributesSection: quoteAttributesSection = {
    totalCost: null as any | null,
    isVisible: false,
    isDataLoaded: false,
    isLoading: false,
    retryCount: 0,
    addNewVisible: false,
    isSectionCompleted: false,
    chatHistory: [],
    isEditable: false,
    sectionName: "",
    canCalculate: false,
    getChatHistory: () => [],
    buildChatHistory: () => { },
    clearChatHistory: () => { },
    calculateTotal: () => { }
  };

  directQuoteAssistProperties: DirectQuoteAssistProperties = this.initializeDirectQuoteAssistProperties()
  quoteAssistModel: DirectQuoteAssistModel = this.initializeDirectQuoteAssistModel()
  // quoteAssistModel: QuoteAssistModel = this.initializeQuoteAssistModel()

  quoteAssist: QuoteAssist = this.initializeQuoteAssist()

  rfqData: DirectRfq = {
    rfqId: '',
    rfqName: '',
    companyId: 0,
    supplierId: 0,
    rfqPartList: [
      {
        rfqPartId: '',
        partName: '',
        partDescription: '',
        process: '',
        technique: '',
        material: '',
        postProduction: '',
        tolerance: '',
        width: 0.00,
        height: 0.00,
        depth: 0.00,
        length: '',
        diameter: '',
        geometry: '',
        dimensionUnit: '',
        rfqNda: '',
        rfqLocation: '',
        qty1: 0,
        qty2: 0,
        qty3: 0,
        pdfFiles: [],
        isAssistEnabled: false,
        isAssistSkipped: false,
        isPartCompleted: false,
        quoteAssistData: this.quoteAssist,
        partQuantity: [],
        isPartNameFilled: false
      }
    ],
    buyerAddress: '',
    buyerEmail: '',
    supplierMetaData: '',
    data: {},
    quoteExpiryDate: '',
    paymentTerm: '',
    quoteNumber: '',
    rfqMetaData: '',

    isQuoteDetailVisible: true,
    isQuoteDetailCompleted: false,
    isQuoteDetailEditable: true,
    isPartSectionVisible: false,
    isPartAdded: false,
    isAssistSectionVisible: false,
    isRfqNameEditable: true,
    isRfqNameEditing: true,
    isConfirmationSectionVisible: false,
    isQuoteConfirmationCompleted: false,
    isQuoteConfirmationVisible: false,
    quoteDate: '',
    // paymentTerms: '' as "" | "Net 15" | "Net 30" | "Net 45" | "Net 60",
    rfqPartDetails: {
      partId: '',
      partName: '',
      qty1: 0,
      isUpdated: false,
      files: []
    },
    billTo: {
      companyName: '',
      address: '',
      city: '',
      zipCode: '',
      state: '',
      companyEmail: '',
      companyPhoneNumber: ''
    }
  };

  currentPart: RfqPart = {
    rfqPartId: '',
    partName: '',
    partDescription: '',
    process: '',
    technique: '',
    material: '',
    postProduction: '',
    tolerance: '',
    width: null,
    height: null,
    depth: null,
    length: '',
    diameter: '',
    dimensionUnit: '',
    geometry: '',
    qty1: null,
    qty2: null,
    qty3: null,
    rfqNda: '',
    rfqLocation: '',
    pdfFiles: [],
    isAssistEnabled: false,
    isAssistSkipped: false,
    isPartCompleted: false,
    quoteAssistData: this.quoteAssist,
    partQuantity: [],
    isPartNameFilled: false
  };

  partNameError = false;

  // @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('rfqNameInput', { static: false }) rfqNameInput!: ElementRef;

  private rfqNameSubscription: Subscription;

  initializeBlankManufacturingSection() {
    return {
      processName: "",
      totalLaborCost: 0.00,
      cycleTimePerUnit: null as any,
      totalLaborTimeInMinutes: null as any,
      totalMachineTimeInMinutes: 0,
      totalMachiningCost: 0.00,
      laborCostPerMinute: null as any,
      machineCostPerMinute: null as any,
      description: "",
      isEditable: false
    }
  }

  initializeBlankToolingSection() {
    return {
      toolName: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: false
    }
  }

  initializeBlankAMRSection() {
    return {
      processName: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: true
    }
  }

  initializeBlankOverheadSection() {
    return {
      overheadTitle: "",
      estimatedCost: 0.00,
      category: "",
      purpose: "",
      isEditable: false
    }
  }

  initializeBlankOtherSection() {
    return {
      processName: "",
      estimatedCost: 0.00,
      description: "",
      isEditable: false
    }
  }

  workflow: any = [
    {
      sectionName: "Complexity"

    },
    {
      sectionName: "Material"

    },
    { sectionName: "Tooling" },
    { sectionName: "Manufacturing" },
    { sectionName: "Machining" },
    { sectionName: "Labor" },
    { sectionName: "AMR" },
    { sectionName: "Overhead" },
    { sectionName: "OtherCosts" },
    { sectionName: "S&H" },
    { sectionName: "ProfitMargin" },
  ]

  private originalQuoteDetails: any = {};

  // Add properties to track validation errors for each field
  validationErrors: {
    rfqName: boolean;
    quoteNumber: boolean;
    quoteDate: boolean;
    quoteExpiryDate: boolean;
    paymentTerm: boolean;
    companyName: boolean;
    address: boolean;
    city: boolean;
    zipCode: boolean;
    state: boolean;
    companyEmail: boolean;
    companyPhoneNumber: boolean;
  } = {
    rfqName: false,
    quoteNumber: false,
    quoteDate: false,
    quoteExpiryDate: false,
    paymentTerm: false,
    companyName: false,
    address: false,
    city: false,
    zipCode: false,
    state: false,
    companyEmail: false,
    companyPhoneNumber: false
  };

  constructor(
    private directQuoteAssistService: DirectQuoteAssistService,
    private quoteAssistService: QuoteAssistService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private rfqNameService: RfqNameService
  ) {
    super();
    this.today = new Date().toISOString().split('T')[0];
    this.rfqNameSubscription = this.rfqNameService.rfqName$.subscribe(name => {
      if (this.rfqData) {
        this.rfqData.rfqName = name;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['companyId']) {
        this.queryParams.companyId = Number(params['companyId']);
        this.queryParams.rfqPartId = params['rfqPartId'];
        this.queryParams.contactId = Number(params['contactId']);
        this.queryParams.isTrackingEnabled = params['isTrackingEnabled'];
        this.queryParams.integration = params['integration'];
        this.isTrackingEnabled = this.queryParams.isTrackingEnabled;
        this.getParamsFromParent();
      }
    });
  }

  ngOnDestroy() {
    if (this.rfqNameSubscription) {
      this.rfqNameSubscription.unsubscribe();
    }
  }

  getMinValidUntilDate(): string {
    if (this.rfqData.quoteDate) {
      const minDate = new Date(this.rfqData.quoteDate);
      minDate.setDate(minDate.getDate());
      return minDate.toISOString().split('T')[0];
    }
    return this.today;
  }
  validateValidUntilDate() {
    if (this.rfqData.quoteDate && this.rfqData.quoteExpiryDate) {
      const quoteDate = new Date(this.rfqData.quoteDate);
      const validUntil = new Date(this.rfqData.quoteExpiryDate);

      if (validUntil < quoteDate) {
        this.rfqData.quoteExpiryDate = '';
        // const minValidDate = new Date(quoteDate);
        // minValidDate.setDate(minValidDate.getDate() + 1);
        // this.rfqData.quoteExpiryDate = minValidDate.toISOString().split('T')[0];
      }
    }
  }
  // onQuoteDateChange(newDate: string) {
  //   if (newDate) {
  //       const nextDay = new Date(newDate);
  //       nextDay.setDate(nextDay.getDate() + 1);
  //       this.rfqData.quoteExpiryDate = nextDay.toISOString().split('T')[0];
  //   }
  // }

  initializeQuoteAssist() {
    return {
      assistedQty: 0,
      quoteModelLoaded: false,
      quoteAssistModel: this.quoteAssistModel
    }
  }

  initializeQuoteAssistModel() {
    return {
      complexityModel: {
        complexity: 0,
        reason: '',
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Complexity',
        getChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.complexityModel.chatHistory.push({
            Text: `Complexity: ${this.quoteAssistModel.complexityModel.complexity} - ${this.quoteAssistModel.complexityModel.reason}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory = [],
        calculateTotal: () => { }
      },
      materials: {
        materialsList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Materials',
        getChatHistory: () => this.quoteAssistModel.materials.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.materials.materialsList.forEach(material => {
            this.quoteAssistModel.materials.chatHistory.push({
              Text: `${material.name} - ${material.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.materials.chatHistory = [],
        calculateTotal: () => {
          if (this.quoteAssistModel.materials.totalCost == 0) {
            let totalCost: number = this.quoteAssistModel.materials.materialsList.reduce(
              (acc, material) => {
                material.rawMaterialPricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);
                const totalWeight = this.convertInternationalToDecimal(material.totalWeight);
                const pricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);

                if (!isNaN(totalWeight) && !isNaN(pricePerPound)) {
                  let materialTotalCost = totalWeight * pricePerPound;
                  return acc + materialTotalCost;
                }

                return acc;
              }, 0
            );
            this.quoteAssistModel.materials.totalCost = totalCost;
          }
          this.currentPartQty.summaryData.pricePerUnit.materials.unitCost = this.convertInternationalToDecimal(this.quoteAssistModel.materials.totalCost) / (this.currentPart?.quoteAssistData?.assistedQty || 1);
          this.currentPartQty.summaryData.pricePerUnit.materials.totalCost = this.parseAndFormat(this.quoteAssistModel.materials.totalCost);
        }
      },
      tooling: {
        productName: '',
        quantityQuoted: 0,
        toolingList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Tooling',
        getChatHistory: () => this.quoteAssistModel.tooling.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.tooling.toolingList.forEach(tool => {
            this.quoteAssistModel.tooling.chatHistory.push({
              Text: `${tool.toolName} - ${tool.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.tooling.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.materials.calculateTotal();
          let i: number = 0
          this.currentPartQty.summaryData.tooling.toolingList = [];
          this.quoteAssistModel.tooling.toolingList.forEach((tool) => {
            tool.estimatedCost = this.convertInternationalToDecimal(tool.estimatedCost)
            i = i + tool.estimatedCost;
            this.currentPartQty?.summaryData.tooling.toolingList.push({
              toolName: tool.toolName,
              estimatedCost: this.convertInternationalToDecimal(tool.estimatedCost),
            });
          });
          this.quoteAssistModel.tooling.totalCost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.cost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.totalCost = this.parseAndFormat(i);
        }
      },
      manufacturingProcess: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        manufacturingList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'ManufacturingProcess',
        getChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.quoteAssistModel.manufacturingProcess.chatHistory.push({
              Text: `${process.processName} - ${process.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.tooling.calculateTotal();
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(process => ({
            ...process,
            cycleTimePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
            totalMachineTimeInMinutes: this.parseAndFormat(process.cycleTimePerUnit) * this.tryParseInt(this.currentPart.quoteAssistData.assistedQty)
          }));
        }
      },
      machining: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        machiningList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Machining',
        getChatHistory: () => this.quoteAssistModel.machining.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(machining => {
            this.multiplyMachineTimeAndCost(machining);
            this.multiplyLaborTimeAndCost(machining);
            this.quoteAssistModel.machining.chatHistory.push({
              Text: `${machining.processName} - ${machining.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.machining.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
          const totalMachiningCost = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, machining) => {
              // this.addSupplierMetadataForMachining(machining);
              const machineTime = this.parseAndFormat(machining.totalMachineTimeInMinutes)
              const machineCost = this.convertInternationalToDecimal(machining.machineCostPerMinute)
              return acc + machineTime * machineCost;
            }, 0
          );
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList = this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.map(machine => {
            const totalMachineTime = this.parseAndFormat(machine.totalMachineTimeInMinutes);
            const machineCostPerMin = this.convertInternationalToDecimal(machine.machineCostPerMinute);

            return {
              ...machine,
              cycleTimePerUnit: this.parseAndFormat(machine.cycleTimePerUnit),
              machineCostPerMinute: this.convertInternationalToDecimal(machineCostPerMin),
              totalMachiningCost: totalMachineTime * this.convertInternationalToDecimal(machineCostPerMin)
            };
          });

          this.currentPartQty.summaryData.pricePerUnit.machining.machineList = [];
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.currentPartQty.summaryData.pricePerUnit.machining.machineList.push({
              cyclePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
              costPerMin: this.convertInternationalToDecimal(process.machineCostPerMinute)
            })
          });
          this.quoteAssistModel.machining.totalCost = totalMachiningCost;
          this.currentPartQty.summaryData.pricePerUnit.machining.totalCost = totalMachiningCost;
        }
      },
      labor: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        laborList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Labor',
        getChatHistory: () => this.quoteAssistModel.labor.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(labor => {
            this.quoteAssistModel.labor.chatHistory.push({
              Text: `${labor.processName} - ${labor.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.labor.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.machining.calculateTotal();
          let totalLaborCost: number = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, labor) => {
              // this.addSupplierMetadataForLabor(labor);
              return acc + this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
            }, 0
          );
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(labor => ({
            ...labor,
            totalLaborTimeInMinutes: this.parseAndFormat(labor.totalLaborTimeInMinutes),
            laborCostPerMinute: this.convertInternationalToDecimal(labor.laborCostPerMinute),
            totalLaborCost: this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
          }));
          totalLaborCost = this.parseAndFormat(totalLaborCost);
          this.quoteAssistModel.labor.totalCost = totalLaborCost;
          this.currentPartQty.summaryData.pricePerUnit.labor.totalCost = totalLaborCost;
        }
      },
      additionalRequirements: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        additionalRequirementList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'AMR',
        getChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.additionalRequirements.additionalRequirementList.forEach(requirement => {
            this.quoteAssistModel.additionalRequirements.chatHistory.push({
              Text: `${requirement.processName} - ${requirement.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.labor.calculateTotal();
          this.quoteAssistModel.additionalRequirements.additionalRequirementList = this.quoteAssistModel.additionalRequirements.additionalRequirementList.map(amr => ({
            ...amr,
            estimatedCost: this.convertInternationalToDecimal(amr.estimatedCost),
          }));
          let totalAdditionalRequirementsCost = this.quoteAssistModel.additionalRequirements.additionalRequirementList.reduce(
            (acc, requirement) => acc + this.parseAndFormat(requirement.estimatedCost), 0
          );
          totalAdditionalRequirementsCost = this.parseAndFormat(totalAdditionalRequirementsCost);
          this.quoteAssistModel.additionalRequirements.totalCost = totalAdditionalRequirementsCost;
          this.currentPartQty.summaryData.pricePerUnit.additionalManufacturingRequirements.totalCost = totalAdditionalRequirementsCost;
        }
      },
      overhead: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        overheadList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Overhead',
        getChatHistory: () => this.quoteAssistModel.overhead.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.overhead.overheadList.forEach(overhead => {
            this.quoteAssistModel.overhead.chatHistory.push({
              Text: `${overhead.overheadTitle} - ${overhead.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.overhead.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
          this.quoteAssistModel.overhead.overheadList = this.quoteAssistModel.overhead.overheadList.map(overhead => ({
            ...overhead,
            estimatedCost: this.convertInternationalToDecimal(overhead.estimatedCost),
          }));
          const totalOverheadCost = this.quoteAssistModel.overhead.overheadList.reduce(
            (acc, overhead) => acc + this.convertInternationalToDecimal(overhead.estimatedCost), 0
          );
          this.quoteAssistModel.overhead.totalCost = totalOverheadCost;
          this.currentPartQty.summaryData.pricePerUnit.overhead.totalCost = totalOverheadCost;
        }
      },
      otherCosts: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        otherCostList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'OtherCosts',
        getChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.otherCosts.otherCostList.forEach(otherCost => {
            this.quoteAssistModel.otherCosts.chatHistory.push({
              Text: `${otherCost.processName} - ${otherCost.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
          this.quoteAssistModel.otherCosts.otherCostList = this.quoteAssistModel.otherCosts.otherCostList.map(otherCost => ({
            ...otherCost,
            estimatedCost: this.convertInternationalToDecimal(otherCost.estimatedCost),
          }));
          this.currentPartQty.summaryData.miscellaneous.itemList = [];
          const totalOtherCosts = this.quoteAssistModel.otherCosts.otherCostList.reduce(
            (acc, otherCost) => {
              this.currentPartQty.summaryData.miscellaneous.itemList.push({
                estimatedCost: otherCost.estimatedCost,
                itemName: otherCost.processName
              })
              return acc + this.convertInternationalToDecimal(otherCost.estimatedCost)
            }, 0
          );
          this.quoteAssistModel.otherCosts.totalCost = totalOtherCosts;
          this.currentPartQty.summaryData.miscellaneous.cost = totalOtherCosts;
        }
      },
      shipping: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        shippingCharges: 0,
        handlingCharges: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Shipping',
        getChatHistory: () => this.quoteAssistModel.shipping.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.shipping.chatHistory.push({
            Text: `Shipping Charges: ${this.quoteAssistModel.shipping.shippingCharges}, Handling Charges: ${this.quoteAssistModel.shipping.handlingCharges}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.shipping.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
          this.quoteAssistModel.shipping.shippingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.shippingCharges);
          this.quoteAssistModel.shipping.handlingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.handlingCharges);

          const totalShippingCost = this.parseAndFormat(this.quoteAssistModel.shipping.shippingCharges) + this.parseAndFormat(this.quoteAssistModel.shipping.handlingCharges);
          this.quoteAssistModel.shipping.totalCost = totalShippingCost;
          this.currentPartQty.summaryData.shippingHandling.cost = totalShippingCost;
        }
      },
      profit: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        industryStandardProfitMargin: 0,
        description: '',
        totalPrice: 0,
        pricePerUnit: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Profit',
        getChatHistory: () => this.quoteAssistModel.profit.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.profit.chatHistory.push({
            Text: `Profit Margin: ${this.quoteAssistModel.profit.industryStandardProfitMargin} - ${this.quoteAssistModel.profit.description}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.profit.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.calculateTotal();
          this.profitMargin = this.parseAndFormat(this.quoteAssistModel.profit.industryStandardProfitMargin);
          this.currentPartQty.summaryData.tooling.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.miscellaneous.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.pricePerUnit.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.shippingHandling.profitMargin = this.profitMargin;
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.canCalculate = true;

          let total = this.calculateTotal();
          const totalCost = total.totalCost;
          let pricePerUnit = total.pricePerUnit;
          let totalCostProfit = total.totalCostProfit;

          this.currentPart.quoteAssistData.quoteAssistModel.profit.pricePerUnit = pricePerUnit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalPrice = totalCostProfit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalCost = totalCost;
        }
      },
      quantity: {
        quantity: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        sectionName: 'Quantity',
        canCalculate: false,
        totalCost: 0,
        getChatHistory: () => [],
        buildChatHistory: () => { },
        clearChatHistory: () => { },
        calculateTotal: () => { }
      }
    };
  }

  initializeDirectQuoteAssistProperties() {
    return {
      isQuoteDetailVisible: true,
      isQuoteDetailCompleted: false,
      isQuoteDetailEditable: true,
      isPartSectionVisible: false,
      isPartAdded: false,
      isAssistSectionVisible: false,
      rfqId: '',
      rfqName: '',
      isRfqNameEditable: true,
      quoteNumber: '',
      quoteDate: new Date(),
      validUntil: new Date(),
      paymentTerms: '' as "" | "Net 15" | "Net 30" | "Net 45" | "Net 60",
      rfqPartDetails: {
        partId: '',
        partName: '',
        qty1: 0,
        isUpdated: false,
        files: []
      },
      billTo: {
        companyName: '',
        address: '',
        city: '',
        zipCode: '',
        state: '',
        companyEmail: '',
        companyPhoneNumber: ''
      }
    }
  }
  initializeDirectQuoteAssistModel() {
    return {
      complexityModel: {
        complexity: 0,
        reason: '',
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Complexity',
        getChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.complexityModel.chatHistory.push({
            Text: `Complexity: ${this.quoteAssistModel.complexityModel.complexity} - ${this.quoteAssistModel.complexityModel.reason}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.complexityModel.chatHistory = [],
        calculateTotal: () => { }
      },
      materials: {
        materialsList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Materials',
        getChatHistory: () => this.quoteAssistModel.materials.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.materials.materialsList.forEach(material => {
            this.quoteAssistModel.materials.chatHistory.push({
              Text: `${material.name} - ${material.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.materials.chatHistory = [],
        calculateTotal: () => {
          if (this.quoteAssistModel.materials.totalCost == 0) {
            let totalCost: number = this.quoteAssistModel.materials.materialsList.reduce(
              (acc, material) => {
                material.rawMaterialPricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);
                const totalWeight = this.convertInternationalToDecimal(material.totalWeight);
                const pricePerPound = this.convertInternationalToDecimal(material.rawMaterialPricePerPound);

                if (!isNaN(totalWeight) && !isNaN(pricePerPound)) {
                  let materialTotalCost = totalWeight * pricePerPound;
                  return acc + materialTotalCost;
                }

                return acc;
              }, 0
            );
            this.quoteAssistModel.materials.totalCost = totalCost;
          }
          this.currentPartQty.summaryData.pricePerUnit.materials.unitCost = this.convertInternationalToDecimal(this.quoteAssistModel.materials.totalCost) / (this.currentPart?.quoteAssistData?.assistedQty || 1);
          this.currentPartQty.summaryData.pricePerUnit.materials.totalCost = this.parseAndFormat(this.quoteAssistModel.materials.totalCost);
        }
      },
      tooling: {
        productName: '',
        quantityQuoted: 0,
        toolingList: [],
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Tooling',
        getChatHistory: () => this.quoteAssistModel.tooling.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.tooling.toolingList.forEach(tool => {
            this.quoteAssistModel.tooling.chatHistory.push({
              Text: `${tool.toolName} - ${tool.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.tooling.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.materials.calculateTotal();
          let i: number = 0
          this.currentPartQty.summaryData.tooling.toolingList = [];
          this.quoteAssistModel.tooling.toolingList.forEach((tool) => {
            tool.estimatedCost = this.convertInternationalToDecimal(tool.estimatedCost)
            i = i + tool.estimatedCost;
            this.currentPartQty?.summaryData.tooling.toolingList.push({
              toolName: tool.toolName,
              estimatedCost: this.convertInternationalToDecimal(tool.estimatedCost),
            });
          });
          this.quoteAssistModel.tooling.totalCost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.cost = this.parseAndFormat(i);
          this.currentPartQty.summaryData.tooling.totalCost = this.parseAndFormat(i);
        }
      },
      manufacturingProcess: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        manufacturingList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'ManufacturingProcess',
        getChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.quoteAssistModel.manufacturingProcess.chatHistory.push({
              Text: `${process.processName} - ${process.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.manufacturingProcess.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.tooling.calculateTotal();
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(process => ({
            ...process,
            cycleTimePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
            totalMachineTimeInMinutes: this.parseAndFormat(process.cycleTimePerUnit) * this.tryParseInt(this.currentPart.quoteAssistData.assistedQty)
          }));
        }
      },
      machining: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        machiningList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Machining',
        getChatHistory: () => this.quoteAssistModel.machining.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(machining => {
            this.multiplyMachineTimeAndCost(machining);
            this.multiplyLaborTimeAndCost(machining);
            this.quoteAssistModel.machining.chatHistory.push({
              Text: `${machining.processName} - ${machining.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.machining.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
          const totalMachiningCost = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, machining) => {
              // this.addSupplierMetadataForMachining(machining);
              const machineTime = this.parseAndFormat(machining.totalMachineTimeInMinutes)
              const machineCost = this.convertInternationalToDecimal(machining.machineCostPerMinute)
              return acc + machineTime * machineCost;
            }, 0
          );
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList = this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.map(machine => {
            const totalMachineTime = this.parseAndFormat(machine.totalMachineTimeInMinutes);
            const machineCostPerMin = this.convertInternationalToDecimal(machine.machineCostPerMinute);

            return {
              ...machine,
              cycleTimePerUnit: this.parseAndFormat(machine.cycleTimePerUnit),
              machineCostPerMinute: this.convertInternationalToDecimal(machineCostPerMin),
              totalMachiningCost: totalMachineTime * this.convertInternationalToDecimal(machineCostPerMin)
            };
          });

          this.currentPartQty.summaryData.pricePerUnit.machining.machineList = [];
          this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(process => {
            this.currentPartQty.summaryData.pricePerUnit.machining.machineList.push({
              cyclePerUnit: this.parseAndFormat(process.cycleTimePerUnit),
              costPerMin: this.convertInternationalToDecimal(process.machineCostPerMinute)
            })
          });
          this.quoteAssistModel.machining.totalCost = totalMachiningCost;
          this.currentPartQty.summaryData.pricePerUnit.machining.totalCost = totalMachiningCost;
        }
      },
      labor: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        laborList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'Labor',
        getChatHistory: () => this.quoteAssistModel.labor.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.manufacturingProcess.manufacturingList.forEach(labor => {
            this.quoteAssistModel.labor.chatHistory.push({
              Text: `${labor.processName} - ${labor.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.labor.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.machining.calculateTotal();
          let totalLaborCost: number = this.quoteAssistModel.manufacturingProcess.manufacturingList.reduce(
            (acc, labor) => {
              // this.addSupplierMetadataForLabor(labor);
              return acc + this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
            }, 0
          );
          this.quoteAssistModel.manufacturingProcess.manufacturingList = this.quoteAssistModel.manufacturingProcess.manufacturingList.map(labor => ({
            ...labor,
            totalLaborTimeInMinutes: this.parseAndFormat(labor.totalLaborTimeInMinutes),
            laborCostPerMinute: this.convertInternationalToDecimal(labor.laborCostPerMinute),
            totalLaborCost: this.parseAndFormat(labor.totalLaborTimeInMinutes) * this.convertInternationalToDecimal(labor.laborCostPerMinute)
          }));
          totalLaborCost = this.parseAndFormat(totalLaborCost);
          this.quoteAssistModel.labor.totalCost = totalLaborCost;
          this.currentPartQty.summaryData.pricePerUnit.labor.totalCost = totalLaborCost;
        }
      },
      additionalRequirements: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        additionalRequirementList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'AMR',
        getChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.additionalRequirements.additionalRequirementList.forEach(requirement => {
            this.quoteAssistModel.additionalRequirements.chatHistory.push({
              Text: `${requirement.processName} - ${requirement.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.additionalRequirements.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.labor.calculateTotal();
          this.quoteAssistModel.additionalRequirements.additionalRequirementList = this.quoteAssistModel.additionalRequirements.additionalRequirementList.map(amr => ({
            ...amr,
            estimatedCost: this.convertInternationalToDecimal(amr.estimatedCost),
          }));
          let totalAdditionalRequirementsCost = this.quoteAssistModel.additionalRequirements.additionalRequirementList.reduce(
            (acc, requirement) => acc + this.parseAndFormat(requirement.estimatedCost), 0
          );
          totalAdditionalRequirementsCost = this.parseAndFormat(totalAdditionalRequirementsCost);
          this.quoteAssistModel.additionalRequirements.totalCost = totalAdditionalRequirementsCost;
          this.currentPartQty.summaryData.pricePerUnit.additionalManufacturingRequirements.totalCost = totalAdditionalRequirementsCost;
        }
      },
      overhead: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        overheadList: [],
        canCalculate: false,
        isEditable: false,
        sectionName: 'Overhead',
        getChatHistory: () => this.quoteAssistModel.overhead.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.overhead.overheadList.forEach(overhead => {
            this.quoteAssistModel.overhead.chatHistory.push({
              Text: `${overhead.overheadTitle} - ${overhead.purpose}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.overhead.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
          this.quoteAssistModel.overhead.overheadList = this.quoteAssistModel.overhead.overheadList.map(overhead => ({
            ...overhead,
            estimatedCost: this.convertInternationalToDecimal(overhead.estimatedCost),
          }));
          const totalOverheadCost = this.quoteAssistModel.overhead.overheadList.reduce(
            (acc, overhead) => acc + this.convertInternationalToDecimal(overhead.estimatedCost), 0
          );
          this.quoteAssistModel.overhead.totalCost = totalOverheadCost;
          this.currentPartQty.summaryData.pricePerUnit.overhead.totalCost = totalOverheadCost;
        }
      },
      otherCosts: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        otherCostList: [],
        isEditable: false,
        canCalculate: false,
        sectionName: 'OtherCosts',
        getChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.otherCosts.otherCostList.forEach(otherCost => {
            this.quoteAssistModel.otherCosts.chatHistory.push({
              Text: `${otherCost.processName} - ${otherCost.description}`,
              IsUser: false
            });
          });
        },
        clearChatHistory: () => this.quoteAssistModel.otherCosts.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
          this.quoteAssistModel.otherCosts.otherCostList = this.quoteAssistModel.otherCosts.otherCostList.map(otherCost => ({
            ...otherCost,
            estimatedCost: this.convertInternationalToDecimal(otherCost.estimatedCost),
          }));
          this.currentPartQty.summaryData.miscellaneous.itemList = [];
          const totalOtherCosts = this.quoteAssistModel.otherCosts.otherCostList.reduce(
            (acc, otherCost) => {
              this.currentPartQty.summaryData.miscellaneous.itemList.push({
                estimatedCost: otherCost.estimatedCost,
                itemName: otherCost.processName
              })
              return acc + this.convertInternationalToDecimal(otherCost.estimatedCost)
            }, 0
          );
          this.quoteAssistModel.otherCosts.totalCost = totalOtherCosts;
          this.currentPartQty.summaryData.miscellaneous.cost = totalOtherCosts;
        }
      },
      shipping: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        shippingCharges: 0,
        handlingCharges: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Shipping',
        getChatHistory: () => this.quoteAssistModel.shipping.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.shipping.chatHistory.push({
            Text: `Shipping Charges: ${this.quoteAssistModel.shipping.shippingCharges}, Handling Charges: ${this.quoteAssistModel.shipping.handlingCharges}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.shipping.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
          this.quoteAssistModel.shipping.shippingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.shippingCharges);
          this.quoteAssistModel.shipping.handlingCharges = this.convertInternationalToDecimal(this.quoteAssistModel.shipping.handlingCharges);

          const totalShippingCost = this.parseAndFormat(this.quoteAssistModel.shipping.shippingCharges) + this.parseAndFormat(this.quoteAssistModel.shipping.handlingCharges);
          this.quoteAssistModel.shipping.totalCost = totalShippingCost;
          this.currentPartQty.summaryData.shippingHandling.cost = totalShippingCost;
        }
      },
      profit: {
        totalCost: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        industryStandardProfitMargin: 0,
        description: '',
        totalPrice: 0,
        pricePerUnit: 0,
        canCalculate: false,
        isEditable: false,
        sectionName: 'Profit',
        getChatHistory: () => this.quoteAssistModel.profit.chatHistory,
        buildChatHistory: () => {
          this.quoteAssistModel.profit.chatHistory.push({
            Text: `Profit Margin: ${this.quoteAssistModel.profit.industryStandardProfitMargin} - ${this.quoteAssistModel.profit.description}`,
            IsUser: false
          });
        },
        clearChatHistory: () => this.quoteAssistModel.profit.chatHistory = [],
        calculateTotal: () => {
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.calculateTotal();
          this.profitMargin = this.parseAndFormat(this.quoteAssistModel.profit.industryStandardProfitMargin);
          this.currentPartQty.summaryData.tooling.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.miscellaneous.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.pricePerUnit.profitMargin = this.profitMargin;
          this.currentPartQty.summaryData.shippingHandling.profitMargin = this.profitMargin;
          this.currentPart.quoteAssistData.quoteAssistModel.shipping.canCalculate = true;

          let total = this.calculateTotal();
          const totalCost = total.totalCost;
          let pricePerUnit = total.pricePerUnit;
          let totalCostProfit = total.totalCostProfit;

          this.currentPart.quoteAssistData.quoteAssistModel.profit.pricePerUnit = pricePerUnit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalPrice = totalCostProfit;
          this.currentPart.quoteAssistData.quoteAssistModel.profit.totalCost = totalCost;
        }
      },
      quantity: {
        quantity: 0,
        isVisible: false,
        isDataLoaded: false,
        isLoading: false,
        retryCount: 0,
        addNewVisible: false,
        isSectionCompleted: false,
        chatHistory: [],
        isEditable: false,
        sectionName: 'Quantity',
        canCalculate: false,
        totalCost: 0,
        getChatHistory: () => [],
        buildChatHistory: () => { },
        clearChatHistory: () => { },
        calculateTotal: () => { }
      }
    }
  }
  initializeBlankRfqPart() {
    return {
      rfqPartId: '',
      partName: '',
      partDescription: '',
      process: '',
      technique: '',
      material: '',
      postProduction: '',
      tolerance: '',
      width: null,
      height: null,
      depth: null,
      length: '',
      diameter: '',
      dimensionUnit: '',
      geometry: '',
      qty1: null,
      qty2: null,
      qty3: null,
      rfqNda: '',
      rfqLocation: '',
      pdfFiles: [],
      isAssistEnabled: false,
      isAssistSkipped: false,
      isPartCompleted: false,
      quoteAssistData: null,
      partQuantity: []
    };
  }

  private findOrCreateProcessRate(processName: string) {
    let { processRates } = this.rfqData.supplierMetaData;
    if (!processRates || !Array.isArray(processRates)) {
      this.rfqData.supplierMetaData.processRates = [];
      processRates = [];
    }
    let existingProcessRate = false;
    if (processRates.length != 0) {
      existingProcessRate = processRates.find((rate: any) => {
        return rate.processName === processName;
      });
    }

    if (existingProcessRate) {
      return existingProcessRate;
    } else {
      const newProcessRate = {
        processName: processName,
        machineName: processName,
        machineRatePerHour: 0,
        labourRatePerHour: 0,
        overhead: ""
      };
      processRates.push(newProcessRate);
      return newProcessRate;
    }
  }

  addSupplierMetadataForMachining(machine: ManufacturingProcessModel) {
    if (!this.isValidString(machine?.processName)) {
      return;
    }
    const processName = machine?.processName;
    const machineCostPerMinute = this.parseAndFormat(machine?.machineCostPerMinute);

    if (this.rfqData?.supplierMetaData) {
      const processRate: any = this.findOrCreateProcessRate(processName);
      processRate.machineRatePerHour = (machineCostPerMinute * 60).toFixed(2);
    }
  }

  addSupplierMetadataForLabor(labor: ManufacturingProcessModel) {
    if (!this.isValidString(labor?.processName)) {
      return;
    }
    const processName = labor?.processName;
    const laborCostPerMinute = this.parseAndFormat(labor?.laborCostPerMinute);
    if (this.rfqData?.supplierMetaData) {
      const processRate: any = this.findOrCreateProcessRate(processName);
      processRate.labourRatePerHour = (laborCostPerMinute * 60).toFixed(2);
    }
  }

  updateManufacturingProcessFromSupplierMetadata(processes: ManufacturingProcessModel[]) {
    let { processRates } = this.rfqData.supplierMetaData;
    if (!processRates || !Array.isArray(processRates)) {
      return;
    }

    processes.forEach(process => {
      if (!this.isValidString(process?.processName)) {
        return;
      }
      const processName = process?.processName;
      const matchingProcessRate = processRates.find(rate => rate.processName === processName);

      if (matchingProcessRate) {
        const machineRatePerHour = this.parseAndFormat(matchingProcessRate.machineRatePerHour);
        const laborRatePerHour = this.parseAndFormat(matchingProcessRate.labourRatePerHour);

        process.machineCostPerMinute = machineRatePerHour / 60;
        process.laborCostPerMinute = laborRatePerHour / 60;
      }
    });
  }

  generateDefaults<T>(defaultData: T, indexedDBData: Partial<T>): T {
    const result = _.cloneDeep(defaultData);

    let mergeDefaults = (defaultObj: any, indexedDBObj: any) => {
      for (const key in indexedDBObj) {
        if (indexedDBObj.hasOwnProperty(key)) {
          if (
            typeof defaultObj[key] === 'object' &&
            !Array.isArray(defaultObj[key]) &&
            defaultObj[key] !== null
          ) {
            mergeDefaults(defaultObj[key], indexedDBObj[key]);
          } else if (
            Array.isArray(defaultObj[key]) &&
            Array.isArray(indexedDBObj[key])
          ) {
            const defaultArray = defaultObj[key];
            const indexedDBArray = indexedDBObj[key];

            while (indexedDBArray.length > defaultArray.length) {
              defaultArray.push(_.cloneDeep(defaultArray[0]));
            }

            for (let i = 0; i < indexedDBArray.length; i++) {
              if (typeof defaultArray[i] === 'object') {
                mergeDefaults(defaultArray[i], indexedDBArray[i]);
              }
            }
          }
        } else {
          indexedDBObj[key] = _.cloneDeep(defaultObj[key]);
        }
      }
    }

    mergeDefaults(result, indexedDBData);

    return result;
  }

  fetchMetaDataFromAPI() {
    this.showPageDataLoading = true;
    try {
      this.directQuoteAssistService.getMetadata(this.rfqData.rfqId, this.queryParams.companyId).subscribe({
        // this.directQuoteAssistService.getMetadata('1d387a5f-b7dc-4185-8241-98aa537d766c', 1775055).subscribe({
        // next: (apiResponse: MetaDataApiResponse) => {
        next: (apiResponse: any) => {
          try {
            if (apiResponse.data.rfqMetaData != undefined && apiResponse.data.rfqMetaData != null && apiResponse.data.rfqMetaData !== "") {
              this.rfqData = this.parseApiResponse(apiResponse);
              this.getPartForSuggestion();
              this.directQuoteAssistService.setMetadata(this.getAllExtractedContent());
              this.resetAllSections();
              this.getDataFromLLM();
            } else {
              this.showPageDataLoading = false;
            }
          } catch (error) {
            this.handleRfqFetchError(error);
          }
        },
        error: (error) => {
          this.handleRfqFetchError(error);
        },
        complete: () => {
          console.log('Metadata fetching completed.');
        }
      });
    } catch (error) {
      this.handleRfqFetchError(error);
    }
  }

  private handleRfqFetchError(error: any) {
    this.showPageDataLoading = false;
    this.toastrService.error('Failed to fetch data for the RFQ.');
    console.error('Error during metadata fetching:', error);
  }

  getPartForSuggestion() {
    let isPartSelected = false;
    let totalPartCount = this.rfqData.rfqPartList.length;
    let partNoUsed = 1;

    for (const part of this.rfqData.rfqPartList) {
      if (!part.isPartCompleted && !part.isAssistSkipped) {
        isPartSelected = true;
        this.currentPart = part;
        this.getQtyForSuggestion(part);
        break;
      }
      partNoUsed++;
    }
    if (!isPartSelected) {
      for (const part of this.rfqData.rfqPartList) {
        isPartSelected = true;
        this.currentPart = part;
        this.getQtyForSuggestion(part);
        break;
      }
      // if (this.currentPart.isAssistSkipped) {
      //   this.skipQuoteAssist();
      // } else {
      //   this.proceedToQuote();
      // }

    }
    this.showPageDataLoading = false;

    if(!this.rfqData.companyId){
      this.rfqData.companyId = this.queryParams.companyId;
    }
    this.addTracking(this.directQuoteAssistService, TrackingModule.DirectQuoteAssist, TrackingEvents.AssistStarted, this.currentPart, this.rfqData,
      MixPanelEvents.AssistStarted, this.queryParams);
    this.partRangeText = partNoUsed + ' of ' + totalPartCount;
  }

  getQtyForSuggestion(part: RfqPart) {
    if (!part.partQuantity || part.partQuantity.length === 0) {

      this.initializeSummary(part);
      if (part.partQuantity.length === 0) {
        throw new Error("No valid quantities found for the current part.");
      }
    }
    //uncomment below to use the lowest quantity
    //this.currentPartQty = part.partQuantity.reduce((min, current) => current.qty < min.qty ? current : min);
    this.currentPartQty = part.partQuantity[0];
    if(this.currentPartQty.qty == 0){
      this.currentPartQty.qty = part.qty1 || 0;
    }
    this.currentPartQty.isAssisted = true;
    this.currentPart.quoteAssistData.assistedQty = this.currentPartQty.qty;
  }

  initializeSummary(part: RfqPart) {
    const quantities = [part.qty1, part.qty2, part.qty3];
    part.partQuantity = [];
    quantities.forEach((qty, index) => {
      if (qty && qty > 0) {
        part.partQuantity.push({
          order: index + 1,
          qty: qty,
          qtyCompleted: false,
          isAssisted: false,
          summaryData: {
            isCopied: false,
            isCompleted: false,
            isDataLoaded: false,
            tooling: { totalCost: 0, cost: 0, toolingList: [], profitMargin: 0, profitValue: 0 },
            pricePerUnit: {
              materials: { totalCost: 0, unitCost: 0 },
              machining: { totalCost: 0, machineList: [{ cyclePerUnit: 0, costPerMin: 0 }] },
              labor: { totalCost: 0 },
              additionalManufacturingRequirements: { totalCost: 0 },
              overhead: { totalCost: 0 },
              totalPrice: 0,
              profitMargin: 0,
              profitValue: 0,
            },
            miscellaneous: { cost: 0, totalCost: 0, itemList: [], profitMargin: 0, profitValue: 0 },
            shippingHandling: { cost: 0, totalCost: 0, profitMargin: 0, profitValue: 0 },
            leadTime: ""
          }
        });
      }
    });

    if (part.partQuantity.length === 0) {
      part.partQuantity.push({
        order: 1,
        qty: 0,
        qtyCompleted: false,
        isAssisted: false,
        summaryData: {
          isCopied: false,
          isCompleted: false,
          isDataLoaded: false,
          tooling: { totalCost: 0, cost: 0, toolingList: [], profitMargin: 0, profitValue: 0 },
          pricePerUnit: {
            materials: { totalCost: 0, unitCost: 0 },
            machining: { totalCost: 0, machineList: [{ cyclePerUnit: 0, costPerMin: 0 }] },
            labor: { totalCost: 0 },
            additionalManufacturingRequirements: { totalCost: 0 },
            overhead: { totalCost: 0 },
            totalPrice: 0,
            profitMargin: 0,
            profitValue: 0,
          },
          miscellaneous: { cost: 0, totalCost: 0, itemList: [], profitMargin: 0, profitValue: 0 },
          shippingHandling: { cost: 0, totalCost: 0, profitMargin: 0, profitValue: 0 },
          leadTime: ""
        }
      });
    }
  }

  toCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.toCamelCase(item));
    } else if (obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
        acc[camelKey] = this.toCamelCase(obj[key]);
        return acc;
      }, {} as any);
    }
    return obj;
  }

  parseApiResponse(response: MetaDataApiResponse): DirectRfq {
    try {
      let parsedMetaData = {};
      try {
        parsedMetaData = JSON.parse(response.data.rfqMetaData);
      } catch (error) {
        this.handleRfqFetchError("Error during the parsing of RFQ.");
      }

      if (!parsedMetaData || Object.keys(parsedMetaData).length === 0) {
        this.handleRfqFetchError("No data keys could be found after the parsing of RFQ.");
      }

      const parseList = this.toCamelCase(parsedMetaData) as Partial<RfqPart[]>;
      const rfqPartList: RfqPart[] = parseList.map(obj => ({ ...this.rfqData.rfqPartList[0], ...obj }));

      rfqPartList.forEach(part => {
        part.quoteAssistData = _.cloneDeep(this.initializeQuoteAssist());
        part.quoteAssistData.quoteAssistModel = _.cloneDeep(this.quoteAssistModel);
      });

      let parsedSupplierMetaData = {};
      try {
        parsedSupplierMetaData = JSON.parse(response.data.supplierMetaData);
      } catch (error) {
        console.error('Error parsing supplier metadata:', error);
      }

      let formattedSupplierMetaData = {};
      if (!parsedSupplierMetaData || Object.keys(parsedSupplierMetaData).length === 0) {
        console.warn("Supplier metadata is empty, null, or undefined. Setting to empty object.");
      } else {
        formattedSupplierMetaData = this.toCamelCase(parsedSupplierMetaData);
      }

      let parsedRFQMetaData = {};
      try {
        parsedRFQMetaData = JSON.parse(response.data.rfqMetaData);
      } catch (error) {
        console.error('Error parsing supplier metadata:', error);
      }

      let formattedRFQMetaData = {};
      if (!parsedRFQMetaData || Object.keys(parsedRFQMetaData).length === 0) {
        console.warn("RFQ metadata is empty, null, or undefined. Setting to empty object.");
      } else {
        formattedRFQMetaData = this.toCamelCase(parsedRFQMetaData);
      }

      return {
        ...this.rfqData,
        rfqId: response.data.rfqId,
        rfqName: response.data.rfqName,
        buyerAddress: response.data.buyerAddress,
        rfqPartList: rfqPartList,
        supplierMetaData: formattedSupplierMetaData,
        // companyId: response.data.companyId,
        buyerEmail: '',
        rfqMetaData: formattedRFQMetaData,
        data: {},
        isQuoteConfirmationVisible: false
      };
    } catch (error) {
      // Handle any unexpected errors during parsing
      console.error('Unexpected error while parsing API response:', error);
      this.toastrService.error("An unexpected error occurred while processing the RFQ data.");
      throw error; // Re-throw the error if further handling is required upstream
    }
  }

  copyRfqPartToExtractedRfqLLM(rfqPart: RfqPart): ExtractedRfqLLM {
    const extractedRFQLLM: ExtractedRfqLLM = {
      partName: rfqPart.partName,
      partDescription: rfqPart.partDescription,
      process: rfqPart.process,
      technique: rfqPart.technique,
      material: rfqPart.material,
      postProduction: rfqPart.postProduction,
      tolerance: rfqPart.tolerance,
      width: rfqPart.width,
      height: rfqPart.height,
      depth: rfqPart.depth,
      length: rfqPart.length,
      diameter: rfqPart.diameter,
      dimensionUnit: rfqPart.dimensionUnit,
      geometry: rfqPart.geometry,
      qty1: rfqPart.quoteAssistData.assistedQty,
      rfqNda: rfqPart.rfqNda,
      rfqLocation: rfqPart.rfqLocation,
    };

    return extractedRFQLLM;
  }

  getAllExtractedContent(): string {
    let extractedContents: string = '';
    if (this.currentPart) {
      if (this.currentPart.pdfFiles) {
        for (const file of this.currentPart.pdfFiles) {
          if (this.isValidString(file.extractedContent)) {
            extractedContents += `PDF File: ${file.extractedContent}\n`;
          } else {
            extractedContents += `PDF File: ${JSON.stringify(this.copyRfqPartToExtractedRfqLLM(this.currentPart))}`
          }
        }
      } else {
        extractedContents += `PDF File: ${JSON.stringify(this.copyRfqPartToExtractedRfqLLM(this.currentPart))}`
      }
      if (this.rfqData.supplierMetaData) {
        const { processRates, ...supplierMetaDataWithoutProcessRates } = this.rfqData.supplierMetaData as {
          processRates: Array<{
            processName: string;
            machineName: string;
            machineRatePerHour: string;
            labourRatePerHour: string;
            overhead: string;
          }>;
          employeeSize: string;
          myCapabilities: any[];
          myEquipment: any[];
          industryServing: any[];
          myAddress: string;
          zipCode: string;
          additionalInfo: Array<{
            laborRatePerHour: string;
            machineRatePerHour: any;
            pricePerUnitPerCubicInch: any;
            qty_0: string;
            qty_1: string;
            qty_2: string;
          }>;
        };
        extractedContents += `Supplier Information: ${JSON.stringify(supplierMetaDataWithoutProcessRates)}\n`;
      }
      if (this.rfqData.rfqMetaData) {
        const matchingPart = this.rfqData.rfqMetaData.find((part: any) =>
          part.rfqPartId === this.queryParams['rfqPartId']
        );

        if (matchingPart) {
          extractedContents += `RFQ Information: ${JSON.stringify(matchingPart)}\n`;
        }
      }
      if (this.currentPart.quoteAssistData) {
        extractedContents += `Quantity to be considered for the Quote Estimation: ${this.currentPart.quoteAssistData.assistedQty}\n`;
      }
    }
    return extractedContents.toString();
  }

  getParamsFromParent() {
    this.route.queryParams.subscribe(params => {
      this.rfqData.rfqId = params['rfqId'];
      this.rfqData.companyId = params['companyId'];
      this.rfqData.supplierId = params['contactId'];

      if (params['showHeader'] == 0) {
        this.showHeaderLogo = false;
      }
      this.loadDataSequentially();
    });
  }

  calculateMachineTime(manufacturingItem: ManufacturingProcessModel) {
    if (!this.isNullOrBlankOrEmpty(manufacturingItem.cycleTimePerUnit)) {
      manufacturingItem.totalMachineTimeInMinutes = this.convertInternationalToDecimal(manufacturingItem.cycleTimePerUnit) * this.convertInternationalToDecimal(this.currentPart.quoteAssistData.assistedQty)
    }
  }

  loadDataSequentially() {
    if (!this.rfqData.rfqId) {
      return;
    }
    let rfqId = this.rfqData.rfqId.toString();
    let contactId = parseInt(this.rfqData.companyId.toString());
    this.showPageDataLoading = true;
    this.directQuoteAssistService.getSavedDataFromIndexedDB(rfqId).subscribe({
      next: (indexedDBData: DirectRfq | null) => {
        if (indexedDBData) {
          if(!indexedDBData.isQuoteDetailCompleted){
            this.getInfoFilledFromWebsite(rfqId);
          }
          // console.log("✅ Data found in browser instance");
          let showLoader = this.processFetchedData(indexedDBData);
          this.showPageDataLoading = showLoader;
          //this.toastrService.success("Your data has been successfully loaded.");
        } else {
          // console.log("❌ No data found in IndexedDB, checking DynamoDB...");
          //this.toastrService.info("Checking for saved data in the cloud...");
          this.fetchDraftDataFromApi(contactId, rfqId)
        }
      },
      error: (error) => {
        console.error("⚠️ Error fetching from local browser instance:", error);
        //this.toastrService.warning("We encountered an issue while retrieving your data locally. Checking the cloud...");
        this.fetchDraftDataFromApi(contactId, rfqId);
      },
    });
  }


  fetchDraftDataFromApi(contactId: any, rfqId: any) {
    this.directQuoteAssistService.fetchDraft(contactId, rfqId).subscribe({
      next: (dynamoDBData: DirectRfq | null) => {
        if (dynamoDBData && dynamoDBData.data != null) {
          // console.log("✅ Data found in cloud.");
          let parsedDraft = null;
          let showLoader = true;
          if(dynamoDBData.data.rfqPartsMetaData){
            parsedDraft = JSON.parse(dynamoDBData.data.rfqPartsMetaData);
            showLoader = this.processFetchedData(parsedDraft, true);
          } else {
            if(!this.rfqData.isQuoteDetailCompleted){
              this.getInfoFilledFromWebsite(rfqId);
            }
            showLoader = false;
          }
          
          this.saveData().subscribe(
            id => {
              // console.log("Data saved for rfq " + id);
              //this.toastrService.success("Your data has been successfully loaded and saved locally.");
            },
            saveError => {
              // console.error("⚠️ Error saving data on local browser instance.:", saveError);
              //this.toastrService.warning("We encountered an issue while saving your data locally. Please try again later.");
            }
          );
          this.showPageDataLoading = showLoader;
        } else {
          // console.log("❌ No data found in cloud, fetching from API...");
          //this.toastrService.info("No saved data found. Fetching fresh data...");
          this.fetchMetaDataFromAPI();
        }
      },
      error: (error) => {
        // console.error("⚠️ Error fetching from cloud:", error);
        //this.toastrService.warning("We encountered an issue while retrieving your data from the cloud. Attempting to fetch fresh data...");
        this.fetchMetaDataFromAPI();
      },
    });
  }

  /**
   * Combine buyerCompanyAddress and buyerCompanyAddress2 for Company Address display.
   */
  private formatBuyerCompanyAddress(data: {
    buyerCompanyAddress?: string;
    buyerCompanyAddress2?: string;
  } | null | undefined): string {
    const line1 = (data?.buyerCompanyAddress || '').trim();
    const line2 = (data?.buyerCompanyAddress2 || '').trim();
    if (line1 && line2) {
      return `${line1}, ${line2}`;
    }
    return line1 || line2;
  }

  getInfoFilledFromWebsite(rfqId: string){
    this.directQuoteAssistService.getBuyerDetails(rfqId, this.queryParams.companyId).subscribe({
      next: (response: any) => {
        if (response && response.data) {
          this.rfqData = this.generateDefaults(this.rfqData, response.data);
          this.rfqData = _.merge(this.rfqData, response.data);
          
          // Initialize RFQ name in service when data is loaded
          if (response.data.rfqName) {
            this.rfqData.rfqName = response.data.rfqName;
            this.rfqNameService.updateRfqName(response.data.rfqName);
          }
          this.rfqData.billTo.companyName = response.data.buyerCompanyName;
          this.rfqData.billTo.address = this.formatBuyerCompanyAddress(response.data);
          this.rfqData.billTo.city = response.data.buyerCompanyCity;
          this.rfqData.billTo.state = response.data.buyerCompanyState;
          this.rfqData.billTo.zipCode = response.data.buyerCompanyZipCode;
          this.rfqData.billTo.companyEmail = response.data.buyerCompanyEmail;
          this.rfqData.billTo.companyPhoneNumber = response.data.buyerCompanyPhone;

          const rfqMetaData = JSON.parse(response.data.rfqMetaData);
          
          if(this.currentPart.partName == null || this.currentPart.partName == ""){
            this.currentPart.partName = rfqMetaData[0]?.part_name;
            this.rfqData.rfqPartList[0].partName = rfqMetaData[0]?.part_name;
          }

          if(this.currentPart.material == null || this.currentPart.material == ""){
            this.currentPart.material = rfqMetaData[0]?.material;
            this.rfqData.rfqPartList[0].material = rfqMetaData[0]?.material;
          }
          this.inputQty = rfqMetaData[0]?.qty1?.toString() || '';
          this.rfqData.rfqPartList[0].qty1 = rfqMetaData[0]?.qty1;
          this.rfqData.rfqPartList[0].quoteAssistData.assistedQty = rfqMetaData[0]?.qty1;
          this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.quantity.isVisible = true;
          this.quoteAssistModel.quantity.isVisible = true;
          this.currentPart.quoteAssistData.quoteAssistModel.quantity.isVisible = true;
          // this.rfqData.isPartAdded = true;

          const pdfFiles = rfqMetaData[0]?.pdf_files || [];

          if(this.currentPart.partName == null || this.currentPart.partName == ""){
            this.currentPart.partName = rfqMetaData[0]?.part_name;
          }

          if(this.currentPart.material == null || this.currentPart.material == ""){
            this.currentPart.material = rfqMetaData[0]?.material;
          }

          this.rfqData.rfqPartDetails = {
            isUpdated: false,
            files: pdfFiles.map((file: any) => ({
              fileName: file.file_name ? file.file_name.replace(/^.*?_S3_/, '') : "PartFile",
              fileUrl: file.file_url,
              isUpdated: false
            }))
          };
          // this.rfqData.isPartAdded = true;
          // //Update IndexedDB
          this.saveData().subscribe(id => {
          });
          // //Update DynamoDB
          this.draftDirectRFQQuoteData();

          this.showSection(this.currentPart.quoteAssistData.quoteAssistModel.quantity);
          const accordionElement = document.getElementById('collapseOne');
          if (accordionElement) {
            accordionElement.classList.add('show');
          }
        }
      },
      error: (error) => {
        console.error('Error fetching buyer details:', error);
      }
    });
    // showLoader = false;
  }

  processFetchedData(data: DirectRfq, fromDynamoDB: boolean = false) {
    this.rfqData = this.generateDefaults(this.rfqData, data);
    if(!this.rfqData.companyId){
      this.rfqData.companyId = this.queryParams.companyId;
    }
    this.rfqData = _.merge(this.rfqData, data);

    // Initialize RFQ name in service when data is loaded
    if (this.rfqData.rfqName) {
      this.rfqNameService.updateRfqName(this.rfqData.rfqName);
    }

    // Populate rfqPartList.pdfFiles from rfqPartDetails.files
    if (this.rfqData.rfqPartDetails?.files && this.rfqData.rfqPartDetails.files.length > 0) {
      if (!this.rfqData.rfqPartList) {
        this.rfqData.rfqPartList = [];
      }
      
      this.rfqData.rfqPartList.forEach(part => {
        if (!part.pdfFiles) {
          part.pdfFiles = [];
        }
        // Add files from rfqPartDetails to each part's pdfFiles
        const files = this.rfqData.rfqPartDetails?.files;
        if (files) {
          files.forEach(file => {
            if (file) {
              part.pdfFiles.push({
                fileId: Date.now(),
                fileUrl: file.fileUrl || '',
                extractedContent: '',
                fileType: file.fileType || FileType.Drawing2D
              });
            }
          });
        }
      });
    }

    this.getPartForSuggestion();
    this.inputQty = this.currentPart.quoteAssistData.assistedQty.toString();
    this.tempSummaryPartQtyModel = _.cloneDeep(this.currentPart.partQuantity);
    if (this.currentPart.quoteAssistData.quoteModelLoaded) {
      this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel as any;
      this.profitMargin = this.parseAndFormat(this.quoteAssistModel.profit.industryStandardProfitMargin);
      this.calculateAllSections();
      this.updateGrandTotal();
      return false;
    } else {
      if(this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.quantity.isSectionCompleted){
        if (!this.rfqData.rfqPartList.some((part) => part.isPartCompleted === true)) {
          this.fetchMetaDataFromAPI();
          return true;
        } else {
          this.directQuoteAssistService.setMetadata(this.getAllExtractedContent());
          this.getDataFromLLM();
          return true;
        }
      }else{
        this.getPartForSuggestion();
        // if(this.rfqData.isPartAdded){
          this.showSection(this.currentPart.quoteAssistData.quoteAssistModel.quantity);
        // }
        return false;
      }
    }
  }

  hideAllSections() {
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isVisible = false;
    });
    this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel as any;
  }

  calculateAllSections() {
    this.quoteAssistModel.profit.isSectionCompleted = true;
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if (prop != 'complexityModel' && prop != 'quantity') {
        if((this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isSectionCompleted){
          (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].canCalculate = true;
          (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].calculateTotal();
        }
      }
    });
  }

  resetAllSections() {
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if (prop != 'materials' && prop != 'quantity') {
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isLoading = false;
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isVisible = false;
      }
    });
  }

  getDataFromLLM() {
    this.showPageDataLoading = true;
    const retryCount = 5;
    const retryDelayMs = 2000;
    this.directQuoteAssistService.getAllDataFromLLM().pipe(
      retry({
        count: retryCount,
        delay: (error, retryAttempt) => {
          this.toastrService.warning(`Retrying (${retryAttempt + 1}/${retryCount})...`, 'Fetching Data for RFQ.');
          return timer(retryDelayMs);
        }
      }),
      catchError(error => {
        this.toastrService.error('Failed to fetch data RFQ after multiple attempts.', 'Error');
        // console.error('Error fetching data from RFQ after 5 retries:', error);
        return [];
      }),
      finalize(() => {
        this.showPageDataLoading = false;
      })
    ).subscribe({
      next: (response: DirectQuoteAssistModel) => {
        this.loadData(response);
      },
      complete: () => {
        Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
          (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isDataLoaded = true;
          // (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].buildChatHistory();
        });

        this.currentPart.quoteAssistData.quoteModelLoaded = true;
        this.currentPart.quoteAssistData.quoteAssistModel.materials.calculateTotal();
        this.showSection(this.currentPart.quoteAssistData.quoteAssistModel.materials);

        this.saveData().subscribe(id => {
          // console.log("Data saved for RFQ " + id);
        });
      }
    });
  }

  loadData(response: DirectQuoteAssistModel) {
    this.currentPart.quoteAssistData.quoteAssistModel = _.merge(this.currentPart.quoteAssistData.quoteAssistModel, response);
    this.quoteAssistModel = this.currentPart.quoteAssistData.quoteAssistModel as any;
    this.loadDataAndSyncWithSupplierMetadata(this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList);
  }

  loadDataAndSyncWithSupplierMetadata(manufacturingProcesses: ManufacturingProcessModel[]) {
    if (!Array.isArray(manufacturingProcesses)) {
      console.warn("Manufacturing processes are not initialized as an array. Skipping update.");
      return;
    }
    if (this.rfqData?.supplierMetaData) {
      this.updateManufacturingProcessFromSupplierMetadata(manufacturingProcesses);
    }
    console.log("Data loaded and synchronized with supplier metadata.");
  }

  showSection(quoteAttributes: quoteAttributesSection, fromUI: boolean = false) {
    if (fromUI && !quoteAttributes.isSectionCompleted) {
      return;
    }
    this.hideAllSections();
    quoteAttributes.isVisible = true;
    if (!quoteAttributes.isDataLoaded) {
      if (!quoteAttributes.isLoading) {
        quoteAttributes.isLoading = true;
        // quoteAttributes.loadData();
      }
      this.toggleLoader();
    } else {
      quoteAttributes.isLoading = false;
      this.quoteAttributesSection = quoteAttributes;
      this.toggleLoader();
    }
  }

  continueClicked(event: Event, nextSection: quoteAttributesSection, currentSection: quoteAttributesSection) {
    // Reset error flag at the beginning of the method
    this.manufacturingProcessError = false;
    this.amrError = false;
    this.overheadError = false;
    this.otherCostsError = false;
    
    if (this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.addNewVisible) {
      if (!this.saveNewManufacturingProcess()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.addNewVisible) {
      if (!this.saveNewAMR()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.overhead.addNewVisible) {
      if (!this.saveNewOverhead()) {
        event.stopPropagation();
        return;
      }
    }
    if (this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.addNewVisible) {
      if (!this.saveNewOtherCost()) {
        event.stopPropagation();
        return;
      }
    }
    
    // Validate required items exist in each section
    // if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess) {
    //   if (!this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList ||
    //       this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.length === 0) {
    //     // Set the error flag instead of showing toaster
    //     this.manufacturingProcessError = true;
    //     event.stopPropagation();
    //     return;
    //   }
    // } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.tooling) {
    //   if (!this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList ||
    //       this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.length === 0) {
    //     this.toastrService.error("Please add at least one Tooling item to continue");
    //     event.stopPropagation();
    //     return;
    //   }
    // } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements) {
    //   if (!this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList ||
    //       this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.length === 0) {
    //     // Set error flags for AMR section if no items exist
    //     this.amrError = true;
    //     event.stopPropagation();
    //     return;
    //   }
    // } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.overhead) {
    //   if (!this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList ||
    //       this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.length === 0) {
    //     // Set error flag instead of showing toaster
    //     this.overheadError = true;
    //     event.stopPropagation();
    //     return;
    //   }
    // } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.otherCosts) {
    //   if (!this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList ||
    //       this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.length === 0) {
    //     // Set error flag instead of showing toaster
    //     this.otherCostsError = true;
    //     event.stopPropagation();
    //     return;
    //   }
    // }
    
    if (currentSection.sectionName == 'Machining' || currentSection.sectionName == 'Labor') {
      // this.updateSupplierMetadata();
    }
    const eventNameKey = Object.keys(TrackingEvents).find(
      (key) => key.toLowerCase() === currentSection.sectionName.toLowerCase()
    );
    const eventNameValue = eventNameKey ? TrackingEvents[eventNameKey as keyof typeof TrackingEvents] : undefined;
    const mixpanelEventNameValue = eventNameKey ? MixPanelEvents[eventNameKey as keyof typeof MixPanelEvents] : undefined;
    this.addTracking(this.directQuoteAssistService, TrackingModule.DirectQuoteAssist, eventNameValue!.toString(), this.currentPart, this.rfqData,
      mixpanelEventNameValue!.toString(), this.queryParams);

    event.stopPropagation();
    nextSection.calculateTotal();
    currentSection.canCalculate = true;
    currentSection.isSectionCompleted = true;
    this.updateGrandTotal();

    // Update the isSectionCompleted property in rfqData for the current section
    if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.materials) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.materials.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.tooling) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.tooling.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.manufacturingProcess.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.machining) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.machining.isSectionCompleted = true;
    }  else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.labor) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.labor.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.additionalRequirements.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.overhead) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.overhead.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.otherCosts) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.otherCosts.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.shipping) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.shipping.isSectionCompleted = true;
    } else if (currentSection === this.currentPart.quoteAssistData.quoteAssistModel.profit) {
      this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.profit.isSectionCompleted = true;
    }

    this.showSection(nextSection);

    this.saveData().subscribe(id => {
      // console.log("Data saved for RFQ " + id);
    });
  }

  toggleLoader() {
    this.isDataLoaded = true;
    Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
      if ((this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isLoading == true) {
        this.isDataLoaded = false;
        (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isDataLoaded = false;
      }
    });
  }

  toggleAddNewTemplate(selectedItem: quoteAttributesSection) {
    selectedItem.addNewVisible = !selectedItem.addNewVisible;
    this.manufacturingBlankSection = this.initializeBlankManufacturingSection();
    this.blankAMRSection = this.initializeBlankAMRSection();
    this.blankOverheadSection = this.initializeBlankOverheadSection();
    this.blankOtherSection = this.initializeBlankOtherSection();
  }

  editItem(selectedItem: any) {
    selectedItem.isEditable = !selectedItem.isEditable;
  }

  saveNewToolingItem() {
    if (!this.isValidString(this.blankToolingSection.toolName)) {
      const newToolingItem: ToolingModel = {
        toolName: this.blankToolingSection.toolName,
        estimatedCost: Number(this.blankToolingSection.estimatedCost),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.tooling);
      this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.push(newToolingItem);
      this.initializeBlankToolingSection();
    }
  }

  removeToolingItem(toolingItem: ToolingModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.indexOf(toolingItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.tooling.toolingList.splice(index, 1);
    }
  }

  saveNewMaterialItem(materialCostTextbox: HTMLInputElement, toolNameTextbox: HTMLInputElement) {
    if (!this.isValidString(toolNameTextbox.value)) {
      const newMaterialItem: MaterialsModel = {
        name: toolNameTextbox.value,
        weightPerPart: 0,
        totalWeight: 0,
        rawMaterialPricePerPound: 0,
        totalMaterialCost: Number(materialCostTextbox.value),
        description: 'Primary',
        isEditable: false
      };
      toolNameTextbox.value = '';
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.materials);
      this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.push(newMaterialItem);
    }
  }

  removeMaterialItem(materialItem: any) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.indexOf(materialItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.materials.materialsList.splice(index, 1);
    }
  }

  saveNewManufacturingProcess(): boolean {
    if (this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.addNewVisible) {
      let isValid = true;
      
      // Reset all error flags first
      this.manufacturingProcessNameError = false;
      this.manufacturingProcessCycleTimeError = false;
      this.manufacturingProcessTotalLaborTimeError = false;

      // Validate process name
      if (!this.isValidString(this.manufacturingBlankSection.processName)) {
        this.manufacturingProcessNameError = true;
        isValid = false;
      }

      // Validate cycle time
      var cycleTimePerUnit = this.tryParseInt(this.manufacturingBlankSection.cycleTimePerUnit);
      if (cycleTimePerUnit == 0) {
        this.manufacturingProcessCycleTimeError = true;
        isValid = false;
      }

      // Validate labor time
      var totalLaborTimeInMinutes = this.tryParseInt(this.manufacturingBlankSection.totalLaborTimeInMinutes);
      if (totalLaborTimeInMinutes == 0) {
        this.manufacturingProcessTotalLaborTimeError = true;
        isValid = false;
      }

      if (!isValid) {
        return false;
      }

      this.manufacturingBlankSection.cycleTimePerUnit = cycleTimePerUnit;
      this.manufacturingBlankSection.totalLaborTimeInMinutes = totalLaborTimeInMinutes;

      if (this.parseAndFormat(this.manufacturingBlankSection.totalMachineTimeInMinutes) > 0) {
        const newManufacturingItem: ManufacturingProcessModel = {
          processName: this.manufacturingBlankSection.processName,
          description: '',
          cycleTimePerUnit: this.manufacturingBlankSection.cycleTimePerUnit,
          totalMachineTimeInMinutes: this.manufacturingBlankSection.totalMachineTimeInMinutes,
          machineCostPerMinute: null as any,
          totalMachiningCost: 0,
          totalLaborTimeInMinutes: this.manufacturingBlankSection.totalLaborTimeInMinutes,
          laborCostPerMinute: null as any,
          totalLaborCost: 0,
          isEditable: false
        };
        this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess);
        this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.push(newManufacturingItem);
        this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
        this.manufacturingBlankSection = this.initializeBlankManufacturingSection();
      }
      return true;
    }
    return true;
  }

  // Below remove function works for Manufacturing Process, Machining and Labor
  removeManufacturingItem(manufacturingItem: ManufacturingProcessModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.indexOf(manufacturingItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.manufacturingList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.manufacturingProcess.calculateTotal();
    }
  }

  saveNewAMR() {
    if (!this.isValidString(this.blankAMRSection.processName)) {
      // Set error flag instead of showing toaster
      this.amrProcessNameError = true;
      return false
    }

    if (this.parseAndFormat(this.blankAMRSection.estimatedCost) == 0) {
      // Set error flag instead of showing toaster
      this.amrEstimatedCostError = true;
      return false;
    }
    if (this.isValidString(this.blankAMRSection.processName)) {
      const newAMRSection: AdditionalRequirementsModel = {
        processName: this.blankAMRSection.processName,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankAMRSection.estimatedCost)),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.push(newAMRSection);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
      this.blankAMRSection = this.initializeBlankAMRSection();
    }
    return true;
  }

  removeAMRItem(additionalItem: AdditionalRequirementsModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.indexOf(additionalItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.additionalRequirementList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.additionalRequirements.calculateTotal();
    }
  }

  saveNewOverhead() {
    if (!this.isValidString(this.blankOverheadSection.overheadTitle)) {
      // Set error flag instead of showing toaster
      this.overheadTitleError = true;
      return false;
    }
    if (this.parseAndFormat(this.blankOverheadSection.estimatedCost) == 0) {
      // Set error flag instead of showing toaster
      this.overheadEstimatedCostError = true;
      return false;
    }
    if (this.isValidString(this.blankOverheadSection.overheadTitle)) {
      const newOverheadSection: OverheadModel = {
        overheadTitle: this.blankOverheadSection.overheadTitle,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankOverheadSection.estimatedCost)),
        category: 'Primary',
        purpose: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.overhead);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.push(newOverheadSection);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
      this.blankOverheadSection = this.initializeBlankOverheadSection();
    }
    return true;
  }

  removeOverheadItem(overheadItem: OverheadModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.indexOf(overheadItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.overheadList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.overhead.calculateTotal();
    }
  }

  saveNewOtherCost() {
    if (!this.isValidString(this.blankOtherSection.processName)) {
      // Set error flag instead of showing toaster
      this.otherCostsProcessNameError = true;
      return false;
    }
    if (this.parseAndFormat(this.blankOtherSection.estimatedCost) == 0) {
      // Set error flag instead of showing toaster
      this.otherCostsEstimatedCostError = true;
      return false;
    }
    if (this.isValidString(this.blankOtherSection.processName)) {
      const newOtherSection: OtherCostModel = {
        processName: this.blankOtherSection.processName,
        estimatedCost: Number(this.convertInternationalToDecimal(this.blankOtherSection.estimatedCost)),
        description: '',
        isEditable: false
      };
      this.toggleAddNewTemplate(this.currentPart.quoteAssistData.quoteAssistModel.otherCosts);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.push(newOtherSection);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
      this.blankOtherSection = this.initializeBlankOtherSection();
    }
    return true;
  }

  removeOtherCostItem(otherCostItem: OtherCostModel) {
    const index = this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.indexOf(otherCostItem);
    if (index > -1) {
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.otherCostList.splice(index, 1);
      this.currentPart.quoteAssistData.quoteAssistModel.otherCosts.calculateTotal();
    }
  }

  multiplyMachineTimeAndCost(selectedItem: ManufacturingProcessModel) {
    selectedItem.totalMachiningCost = Number(selectedItem.totalMachineTimeInMinutes) * Number(selectedItem.machineCostPerMinute);
  }

  multiplyLaborTimeAndCost(selectedItem: ManufacturingProcessModel) {
    selectedItem.totalLaborCost = Number(selectedItem.totalLaborTimeInMinutes) * Number(selectedItem.laborCostPerMinute);
  }

  manufacturingTotalLaborTime() {
    return this.currentPart.quoteAssistData.quoteAssistModel?.manufacturingProcess?.manufacturingList.reduce((acc, item) => acc + this.convertInternationalToDecimal(item.totalLaborTimeInMinutes), 0);
  }

  manufacturingTotalMachineTime() {
    return this.currentPart.quoteAssistData.quoteAssistModel?.manufacturingProcess?.manufacturingList.reduce((acc, item) => acc + this.convertInternationalToDecimal(item.totalMachineTimeInMinutes), 0);
  }

  quotes: string[] = [
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Do not wait to strike till the iron is hot, but make it hot by striking.",
    "Act as if what you do makes a difference. It does."
  ];

  currentQuote: string = this.quotes[0];

  generateRandomQuote(): void {
    const randomIndex = Math.floor(Math.random() * this.quotes.length);
    this.currentQuote = this.quotes[randomIndex];
  }

  additionalTotalCost(): number {
    return this.currentPart.quoteAssistData.quoteAssistModel?.additionalRequirements?.additionalRequirementList
      .filter(item => item.category === 'Primary')
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
  }

  otherTotalCost(): number {
    return this.currentPart.quoteAssistData.quoteAssistModel?.otherCosts?.otherCostList
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
  }
  overHeadRate(): number {
    const totalOverheadRate = this.currentPart.quoteAssistData.quoteAssistModel?.overhead?.overheadList
      .filter(item => item.category === 'Primary')
      .reduce((total, item) => total + Number(item.estimatedCost || 0), 0);
    const totalLaborMinutes = this.manufacturingTotalLaborTime();
    const totalMachineMinutes = this.manufacturingTotalMachineTime();
    return totalOverheadRate * (totalLaborMinutes + totalMachineMinutes);
  }
  navigateToSummaryPage() {
    this.router.navigateByUrl(`direct-quote-summary?rfqId=${this.rfqData.rfqId}&rfqPartId=${this.currentPart.rfqPartId}&companyId=${this.queryParams.companyId}&contactId=${this.queryParams.contactId}&isTrackingEnabled=${this.queryParams.isTrackingEnabled}&integration=${this.queryParams.integration}&isSkipped=false`);
  }
  proceedToQuote() {
    this.quoteAssistModel.complexityModel.isSectionCompleted = true;
    this.quoteAssistModel.manufacturingProcess.isSectionCompleted = true;
    this.quoteAssistModel.tooling.isSectionCompleted = true;
    this.quoteAssistModel.materials.isSectionCompleted = true;
    this.quoteAssistModel.machining.isSectionCompleted = true;
    this.quoteAssistModel.labor.isSectionCompleted = true;
    this.quoteAssistModel.additionalRequirements.isSectionCompleted = true;
    this.quoteAssistModel.overhead.isSectionCompleted = true;
    this.quoteAssistModel.profit.isSectionCompleted = true;
    this.quoteAssistModel.otherCosts.isSectionCompleted = true;
    this.quoteAssistModel.shipping.isSectionCompleted = true;
    this.quoteAssistModel.quantity.isSectionCompleted = true;

    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.complexityModel.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.manufacturingProcess.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.tooling.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.materials.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.machining.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.labor.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.additionalRequirements.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.overhead.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.profit.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.otherCosts.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.shipping.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.quantity.isSectionCompleted = true;

    // this.rfqData.rfqPartList[0].quoteAssistData.quoteAssistModel.profit.isSectionCompleted = true;
    this.rfqData.rfqPartList[0].isAssistSkipped = false;
    this.currentPart.isAssistSkipped = false;
    this.currentPart.isAssistEnabled = true;
    this.addTracking(this.directQuoteAssistService, TrackingModule.DirectQuoteAssist, TrackingEvents.ProceedSummary, this.currentPart, this.rfqData,
      MixPanelEvents.ProceedSummary, this.queryParams);
    
    this.saveData(true).subscribe(id => {
      this.navigateToSummaryPage();
    });
  }

  skipQuoteAssist() {
    if (this.currentPart) {
      this.rfqData.rfqPartList[0].isAssistSkipped = true;
      this.currentPart.qty1 = this.currentPart.quoteAssistData.assistedQty;
      this.currentPart.isAssistSkipped = true;
      if (this.currentPart.isAssistEnabled) {
        this.initializeSummary(this.currentPart);
        this.currentPart.isAssistEnabled = false;
      } else {
        if (this.tempSummaryPartQtyModel.length > 0) {
          this.tempSummaryPartQtyModel.forEach(item => { item.qty = this.currentPart.qty1 || 0 });
          this.currentPart.partQuantity = this.tempSummaryPartQtyModel;
          if(this.currentPart.partQuantity[0].qty == 0){
            this.currentPart.partQuantity[0].qty = this.currentPart.qty1;
          }
        }
      }
      // this.pushTrackingDataToMFG("supplier quote assist skip to quote");
      if(!this.rfqData.companyId){
        this.rfqData.companyId = this.queryParams.companyId;
      }

      this.addTracking(
        this.directQuoteAssistService, 
        TrackingModule.DirectQuoteAssist, 
        TrackingEvents.SkipAssist, 
        this.currentPart, 
        this.rfqData,
        MixPanelEvents.SkipAssist, 
        this.queryParams
      );

      this.saveData(true).subscribe(id => {
        this.router.navigateByUrl(`direct-quote-summary?rfqId=${this.rfqData.rfqId}&rfqPartId=${this.currentPart.rfqPartId}&companyId=${this.queryParams.companyId}&contactId=${this.queryParams.contactId}&isTrackingEnabled=${this.queryParams.isTrackingEnabled}&integration=${this.queryParams.integration}&isSkipped=true`);
        // this.navigateToSummaryPage();
      });
    } else {
      this.toastrService.error("Something went wrong while fetching your data. Please close the assist and try again.");
    }
  }

  saveData(copySummary: boolean = false) {
    if (this.currentPart && copySummary && !this.currentPart.isAssistSkipped) {
      this.copySummaryDataToAllQuantities(this.currentPart);
    }
    if(!this.rfqData.companyId){
      this.rfqData.companyId = this.queryParams.companyId;
    }
    return this.directQuoteAssistService.storeQuoteAssistData(this.rfqData);
  }

  copySummaryDataToAllQuantities(part: RfqPart): void {
    try {
      if (!part || Object.keys(part).length === 0) {
        console.error('The part object is empty, null, or undefined.');
        this.reinitializePart(part);
        return;
      }

      if (!part.partQuantity || part.partQuantity.length === 0) {
        console.warn('No quantities available to copy summary data.');
        return;
      }

      if (!this.currentPartQty || Object.keys(this.currentPartQty).length === 0) {
        console.error('The currentPartQty object is empty, null, or undefined.');
        this.reinitializeCurrentPartQty();
        return;
      }
      let sourceSummaryData = this.currentPartQty.summaryData;
      if (!sourceSummaryData || Object.keys(sourceSummaryData).length === 0) {
        this.initializeSummary(part);
        sourceSummaryData = this.currentPartQty.summaryData;
        return;
      }
      if (!this.currentPartQty.summaryData.isCopied) {
        this.currentPartQty.summaryData.isCopied = true;
        sourceSummaryData.isCopied = true;
        part.partQuantity.forEach((quantity) => {
          quantity.summaryData = _.cloneDeep(sourceSummaryData);
        });
      }
    } catch (error) {
      console.error('Unexpected error while copying summary data:', error);
      this.toastrService.error('An unexpected error occurred while creating the summary for the quote.');
      throw error;
    }
  }

  private reinitializePart(part: RfqPart): void {
    console.log('Reinitializing the part object...');
  }

  private reinitializeCurrentPartQty(): void {
    console.log('Reinitializing the currentPartQty object...');
  }

  calculateTotal() {
    const { materials, machining, labor, additionalManufacturingRequirements, overhead } = this.currentPartQty.summaryData.pricePerUnit;
    const { tooling, miscellaneous, shippingHandling } = this.currentPartQty.summaryData;
    const { quoteAssistModel } = this.currentPart.quoteAssistData

    const qty = this.convertInternationalToDecimal(this.currentPartQty.qty);
    const materialsCost = quoteAssistModel.materials.canCalculate ? (this.convertInternationalToDecimal(materials.unitCost) * qty) : 0;
    const machiningCost = quoteAssistModel.machining.canCalculate ? (this.parseAndFormat(machining.machineList.reduce(
      (acc, item) => acc + this.convertInternationalToDecimal(item.costPerMin) * this.convertInternationalToDecimal(item.cyclePerUnit), 0
    )) * qty) : 0;
    const laborCost = quoteAssistModel.labor.canCalculate ? this.convertInternationalToDecimal(labor.totalCost) : 0;
    const amrCost = quoteAssistModel.additionalRequirements.canCalculate ? this.convertInternationalToDecimal(additionalManufacturingRequirements.totalCost) : 0;
    const overheadCost = quoteAssistModel.overhead.canCalculate ? this.convertInternationalToDecimal(overhead.totalCost) : 0;

    const toolingCost = quoteAssistModel.tooling.canCalculate ? this.convertInternationalToDecimal(tooling.totalCost) : 0;
    const miscellaneousCost = quoteAssistModel.otherCosts.canCalculate ? miscellaneous.itemList.reduce(
      (acc, otherCost) => {
        return acc + this.convertInternationalToDecimal(otherCost.estimatedCost)
      }, 0
    ) : 0;
    const shippingHandlingCost = quoteAssistModel.shipping.canCalculate ? this.convertInternationalToDecimal(shippingHandling.cost) : 0;

    let pricePerUnit = this.parseAndFormat(
      this.parseAndFormat(materialsCost) +
      this.parseAndFormat(machiningCost) +
      laborCost +
      amrCost +
      overheadCost
    );

    let toolingCostTotal, miscellaneousCostTotal, shippingHandlingCostTotal, pricePerUnitTotal;

    toolingCostTotal = this.parseAndFormat((toolingCost * (1 + (this.convertInternationalToDecimal(tooling.profitMargin) / 100))))
    pricePerUnitTotal = this.parseAndFormat((((pricePerUnit / qty) * (1 + (this.convertInternationalToDecimal(this.currentPartQty.summaryData.pricePerUnit.profitMargin) / 100)))));
    miscellaneousCostTotal = this.parseAndFormat(this.parseAndFormat((miscellaneousCost) * (1 + (this.convertInternationalToDecimal(miscellaneous.profitMargin) / 100))));
    shippingHandlingCostTotal = this.parseAndFormat(this.parseAndFormat((shippingHandlingCost) * (1 + (this.convertInternationalToDecimal(shippingHandling.profitMargin) / 100))));

    const totalCostProfit = this.parseAndFormat((toolingCostTotal + (pricePerUnitTotal * qty) + miscellaneousCostTotal + shippingHandlingCostTotal));

    const totalCost = this.parseAndFormat(totalCostProfit / (1 + (this.convertInternationalToDecimal(this.profitMargin) / 100)));

    return { pricePerUnit: pricePerUnitTotal, totalCost: totalCost, totalCostProfit: totalCostProfit };
  }

  updateGrandTotal(): void {
    const costing = this.calculateTotal();
    let totalCost = this.parseAndFormat(costing.totalCost.toFixed(2));

    if (this.currentPart.quoteAssistData.quoteAssistModel.shipping.isSectionCompleted) {
      totalCost = costing.totalCostProfit
    }

    this.quoteGrandTotal = totalCost;
  }

  saveDraft() {
    this.addTracking(this.directQuoteAssistService, TrackingModule.DirectQuoteAssist, TrackingEvents.SaveToDraft, this.currentPart, this.rfqData,
      MixPanelEvents.SaveToDraft, this.queryParams);
    this.showPageDataLoading = true;
    const payload = {
      CompanyId: this.rfqData!.companyId,
      SupplierId: this.rfqData!.supplierId,
      RfqId: this.rfqData!.rfqId,
      QuoteStatus: QuoteStatus.Draft,
      RfqPartsMetaData: JSON.stringify(this.rfqData)
    };

    this.directQuoteAssistService.saveDraft(payload).subscribe({
      next: (response: number) => {
        this.saveData().subscribe(id => {
          // console.log("Data saved for RFQ " + id);
        });
        this.showPageDataLoading = false;
        this.toastrService.success("Draft saved successfully.");
        // console.log('Draft saved successfully with ID:', response);
      },
      error: (error) => {
        console.error('Error saving draft:', error);
      }
    });
  }
  fetchDraft(): Observable<any> {
    return this.directQuoteAssistService.fetchDraft(this.rfqData!.companyId, this.rfqData!.rfqId);
  }
  openPartFileInNewTab() {
    if (window.parent) {
      window.parent.postMessage({ openPartFileInNewTab: true }, "*");
    }
  }
  pushTrackingDataToMFG(eventName: string, dataToSend: any = {}) {
    if (window.parent) {
      let dataToEmit: any = Object.assign({ isQuoteAssistTracking: true }, this.queryParams);
      dataToEmit = Object.assign(dataToEmit, dataToSend)
      dataToEmit["eventName"] = eventName;
      window.parent.postMessage(dataToEmit, "*");
    }
  }

  updateSupplierMetadata() {

    const payload = {
      CompanyId: parseInt(this.rfqData!.companyId.toString()),
      MetaData: JSON.stringify(this.rfqData.supplierMetaData)
    };

    this.directQuoteAssistService.saveCompanyMetaData(payload).subscribe({
      next: (response: number) => {
        // console.log("Supplier Company Metadata updated");
      },
      error: (error) => {
        console.error('Error updating company metadata: ', error);
      }
    });
  }

  toggleTooltip(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    const tooltip = target.parentElement?.querySelector('.tooltip-popup') as HTMLElement;

    // Close any other open tooltips first
    document.querySelectorAll('.tooltip-popup.show').forEach(element => {
      if (element !== tooltip) {
        element.classList.remove('show');
      }
    });

    // Toggle this tooltip
    if (tooltip.classList.contains('show')) {
      tooltip.classList.remove('show');
    } else {
      // Position the tooltip relative to the clicked element
      const rect = target.getBoundingClientRect();

      // Position above the icon
      tooltip.style.bottom = (window.innerHeight - rect.top + 10) + 'px';

      // Center horizontally, but ensure it stays within viewport
      let leftPos = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2);

      // Adjust if tooltip would go off-screen
      if (leftPos < 20) {
        leftPos = 20; // Min 20px from left edge
      } else if (leftPos + tooltip.offsetWidth > window.innerWidth - 20) {
        leftPos = window.innerWidth - tooltip.offsetWidth - 20; // Min 20px from right edge
      }

      tooltip.style.left = leftPos + 'px';

      // Position the arrow
      const arrowLeft = rect.left + (rect.width / 2) - leftPos;
      tooltip.style.setProperty('--arrow-left', arrowLeft + 'px');

      // Show the tooltip
      tooltip.classList.add('show');

      // Adjust the z-index to be above all elements
      tooltip.style.zIndex = '9999';
    }

    // Close tooltip when clicking outside
    const closeTooltips = (e: MouseEvent) => {
      if (!target.contains(e.target as Node) && !tooltip.contains(e.target as Node)) {
        tooltip.classList.remove('show');
        document.removeEventListener('click', closeTooltips);
      }
    };

    // Add click handler with a small delay to prevent immediate closing
    setTimeout(() => {
      document.addEventListener('click', closeTooltips);
    }, 100);

    event.stopPropagation();
  }

  showQuoteDetailSection() {
    this.rfqData.isQuoteDetailVisible = true;
    this.rfqData.isAssistSectionVisible = false;
    this.rfqData.isQuoteConfirmationVisible = false;
  }
  enableQuoteDetailSection() {
    this.rfqData.isQuoteDetailEditable = true;
  }
  disableQuoteDetailSection() {
    this.rfqData.isQuoteDetailEditable = false;
  }
  showAssistSection() {
    this.rfqData.isQuoteDetailVisible = false;
    this.rfqData.isAssistSectionVisible = true;
    this.rfqData.isQuoteConfirmationVisible = false;
  }

  validateQuoteDetails(): { isValid: boolean, message: string, fieldName?: string } {
    // Reset all validation errors
    Object.keys(this.validationErrors).forEach(key => {
      this.validationErrors[key as keyof typeof this.validationErrors] = false;
    });

    let allErrors: string[] = [];
    let isValid = true;

    if (!this.rfqData.rfqName?.trim() || this.rfqData.rfqName === 'Enter RFQ Name') {
      this.validationErrors.rfqName = true;
      allErrors.push('RFQ Name');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.companyName?.trim()) {
      this.validationErrors.companyName = true;
      allErrors.push('Company Name');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.companyEmail?.trim()) {
      this.validationErrors.companyEmail = true;
      allErrors.push('Company Email');
      isValid = false;
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.rfqData.billTo.companyEmail)) {
        this.validationErrors.companyEmail = true;
        allErrors.push('Valid Email Address');
        isValid = false;
      }
    }

    if (!this.rfqData.billTo.companyPhoneNumber?.trim()) {
      this.validationErrors.companyPhoneNumber = true;
      allErrors.push('Company Phone Number');
      isValid = false;
    } else {
      // Validate phone number has exactly 10 digits
      const phoneNumber = this.rfqData.billTo.companyPhoneNumber;
      if (phoneNumber.length > 15) {
        this.validationErrors.companyPhoneNumber = true;
        allErrors.push('Valid Phone Number (10 digits)');
        isValid = false;
      }
    }

    if (!this.rfqData.quoteNumber?.trim()) {
      this.validationErrors.quoteNumber = true;
      allErrors.push('Quote Number');
      isValid = false;
    }
    
    if (!this.rfqData.quoteExpiryDate) {
      this.validationErrors.quoteExpiryDate = true;
      allErrors.push('Valid Until Date');
      isValid = false;
    }
    
    if (!this.rfqData.paymentTerm) {
      this.validationErrors.paymentTerm = true;
      allErrors.push('Payment Terms');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.address?.trim()) {
      this.validationErrors.address = true;
      allErrors.push('Address');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.city?.trim()) {
      this.validationErrors.city = true;
      allErrors.push('City');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.state?.trim()) {
      this.validationErrors.state = true;
      allErrors.push('State');
      isValid = false;
    }
    
    if (!this.rfqData.billTo.zipCode?.trim()) {
      this.validationErrors.zipCode = true;
      allErrors.push('Zip Code');
      isValid = false;
    }
    
    // If we have validation errors, create a consolidated error message
    if (!isValid) {
      let message = 'Please fill in the following required fields: ' + allErrors.join(', ');
      return { isValid: false, message: message };
    }

    return { isValid: true, message: '' };
  }

  saveDirectRFQDetails() {
    const validation = this.validateQuoteDetails();
    if (!validation.isValid) {
      return;
    }

    const formData = new FormData();

    formData.append('CompanyId', this.queryParams.companyId.toString());
    if (this.rfqData.rfqId != null && this.rfqData.rfqId.toString() !== '') {
      formData.append('RfqId', this.rfqData.rfqId.toString());
    }
    formData.append('RfqName', this.rfqData.rfqName);
    // formData.append('RfqMetaData', JSON.stringify(this.rfqData.supplierMetaData) || '');
    formData.append('CreatedOn', new Date().toISOString());
    formData.append('Source', this.queryParams.integration);
    // formData.append('SupplierMetaData', JSON.stringify(this.rfqData.supplierMetaData) || '');
    formData.append('BuyerCompanyName', this.rfqData.billTo.companyName);
    formData.append('BuyerCompanyAddress', this.rfqData.billTo.address);
    formData.append('BuyerCompanyEmail', this.rfqData.billTo.companyEmail);
    formData.append('BuyerCompanyPhone', this.rfqData.billTo.companyPhoneNumber);

    this.showPageDataLoading = true;
    this.rfqData.isQuoteDetailEditable = false;
    this.updateDirectRFQDetails().subscribe({
      next: (response: any) => {
        this.rfqData.rfqId = response.data.rfqId.toString();
        this.rfqData.isQuoteDetailVisible = false;
        this.rfqData.isAssistSectionVisible = true;
        this.rfqData.isQuoteConfirmationVisible = false;
        this.rfqData.isQuoteDetailCompleted = true;
        if(this.rfqData.rfqPartDetails){
          this.rfqData!.rfqPartDetails!.partId = "1"; 
        }
        this.showPageDataLoading = false;

        this.saveData(true).subscribe(id => {
          this.disableQuoteDetailSection(); 
          this.draftDirectRFQQuoteData();
          // this.toastrService.success("RFQ saved successfully.");
        });
      },
      error: (error) => {
        console.error('Error saving Direct RFQ:', error);
        this.toastrService.error("Failed to save RFQ.");
        this.showPageDataLoading = false;
      }
    });
  }

  toggleRfqNameEditable() {
    this.rfqData.isRfqNameEditable = !this.rfqData.isRfqNameEditable;
  }

  openFileDialog(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any): void {
    if (this.rfqData.rfqPartDetails?.files) {
      this.rfqData.rfqPartDetails.files.forEach(file => {
        file.isUpdated = false;
      });
    }

    const files = event.target.files;
    if (files && files.length > 0) {
      if (!this.rfqData.rfqPartDetails) {
        this.rfqData.rfqPartDetails = {
          partId: '',
          partName: '',
          qty1: 0,
          isUpdated: false,
          files: []
        };
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.rfqData.rfqPartDetails.files.push({
          fileName: file.name,
          file: file,
          isUpdated: true,
          fileType: FileType.Drawing2D
        });
      }

      this.showPageDataLoading = true;
      this.updateDirectRFQDetails().subscribe({
        next: (response: any) => {
          this.rfqData.rfqId = response.data.rfqId.toString();
          this.rfqData.isPartAdded = true;
          this.showSection(this.currentPart.quoteAssistData.quoteAssistModel.quantity);
          
          // Update the file URL in rfqPartDetails.files
          if (response?.data?.fileUrls && this.rfqData?.rfqPartDetails?.files && this.rfqData.rfqPartDetails.files.length > 0) {
            const lastFileIndex = this.rfqData.rfqPartDetails.files.length - 1;
            this.rfqData.rfqPartDetails.files[lastFileIndex].fileUrl = response.data.fileUrls[lastFileIndex];
          }
          
          //Update IndexedDB
          this.saveData().subscribe(id => {
          });
          //Update DynamoDB
          this.draftDirectRFQQuoteData();
          
          this.directQuoteAssistService.getMetadata(this.rfqData.rfqId, this.queryParams.companyId).subscribe({
            next: (apiResponse: any) => {
              try {
                if (apiResponse.data.rfqMetaData != undefined && apiResponse.data.rfqMetaData != null && apiResponse.data.rfqMetaData !== "") {
                  this.rfqData = this.parseApiResponse(apiResponse);
                  // this.getPartForSuggestion();
                  // this.directQuoteAssistService.setMetadata(this.getAllExtractedContent());
                  // this.resetAllSections();
                  // this.getDataFromLLM();
                } else {
                  this.showPageDataLoading = false;
                }
              } catch (error) {
                this.handleRfqFetchError(error);
              }
            },
            error: (error) => {
              this.handleRfqFetchError(error);
            },
            complete: () => {
              console.log('Metadata fetching completed.');
            }
          });

          this.showPageDataLoading = false;
          this.toastrService.success("Part file(s) uploaded successfully.");
        },
        error: (error) => {
          console.error('Error uploading part file(s):', error);
          this.toastrService.error("Failed to upload part file(s).");
          this.showPageDataLoading = false;
        },
        complete() {
          const accordionElement = document.getElementById('collapseOne');
          if (accordionElement) {
            accordionElement.classList.add('show');
          }
        },
      });
    }
  }

  updateDirectRFQDetails() {
    const formData = new FormData();

    formData.append('CompanyId', this.queryParams.companyId.toString());
    if (this.rfqData.rfqId != null && this.rfqData.rfqId.toString() !== '') {
      formData.append('RfqId', this.rfqData.rfqId.toString());
    }
    formData.append('RfqName', this.rfqData.rfqName);
    formData.append('QuoteDate', this.rfqData.quoteExpiryDate);
    // formData.append('RfqMetaData', JSON.stringify(this.rfqData.supplierMetaData) || '');
    formData.append('CreatedOn', new Date().toISOString());
    formData.append('Source', this.queryParams.integration);
    // formData.append('SupplierMetaData', JSON.stringify(this.rfqData.supplierMetaData) || '');
    formData.append('BuyerCompanyName', this.rfqData.billTo.companyName);
    formData.append('BuyerCompanyAddress', this.rfqData.billTo.address);
    formData.append('BuyerCompanyEmail', this.rfqData.billTo.companyEmail);
    formData.append('BuyerCompanyPhone', this.rfqData.billTo.companyPhoneNumber);
    formData.append('BuyerCompanyCity', this.rfqData.billTo.city);
    formData.append('BuyerCompanyState', this.rfqData.billTo.state);
    formData.append('BuyerCompanyZipCode', this.rfqData.billTo.zipCode);
    formData.append('BuyerAddress', '');

    formData.append('RfqPartDetails.IsUpdated', 'false');
    formData.append('RfqPartDetails.Qty1', this.currentPart?.quoteAssistData?.assistedQty?.toString() || '0');
    formData.append('RfqPartDetails.PartName', this.currentPart?.partName);
    
    if(this.queryParams.integration == "SUW"){
      formData.append('RfqPartDetails.PartId', "1");
    }
    else if(this.rfqData.isPartAdded){
      formData.append('RfqPartDetails.PartId', "1");
    }
   
    if (this.rfqData.rfqPartDetails &&
      this.rfqData.rfqPartDetails.files &&
      this.rfqData.rfqPartDetails.files.length > 0) {

      this.rfqData.rfqPartDetails.files.forEach((fileObj: any, index: number) => {
        if (fileObj && fileObj.file) {
          formData.append(`RfqPartDetails.Files[${index}].File`, fileObj.file);
          formData.append(`RfqPartDetails.Files[${index}].FileName`, fileObj.fileName);
          formData.append(`RfqPartDetails.Files[${index}].IsUpdated`, fileObj.isUpdated ? "true" : "false");
          formData.append(`RfqPartDetails.Files[${index}].FileType`, fileObj.fileType || FileType.Drawing2D);
        }
        else {
          formData.append(`RfqPartDetails.Files[0].File`, "");
          formData.append(`RfqPartDetails.Files[0].FileName`, this.rfqData!.rfqPartDetails!.files[0].fileName);
          formData.append(`RfqPartDetails.Files[0].IsUpdated`, "false");
          formData.append(`RfqPartDetails.Files[0].FileType`, this.rfqData!.rfqPartDetails!.files[0].fileType || FileType.Drawing2D);
        }
      });
    } else {
      formData.append('RfqPartDetails.Files', JSON.stringify([]));
    }
    if (this.rfqData.rfqPartDetails?.files) {
      this.rfqData.rfqPartDetails.files.forEach(file => {
        file.isUpdated = false;
      });
    }
    
    return this.directQuoteAssistService.saveDirectRFQDetails(formData);
  }

  removeFile(fileToRemove: any) {
    const index = this.rfqData?.rfqPartDetails?.files.indexOf(fileToRemove);
    if (index !== undefined && index > -1) {
      this.showPageDataLoading = true;
      this.rfqData.rfqPartDetails?.files.splice(index, 1);
      this.rfqData.rfqPartList[0].pdfFiles.splice(index, 1);
      this.toastrService.success("Part file(s) removed successfully.");
      // this.updateDirectRFQDetails();
      
      this.updateDirectRFQDetails().subscribe({
        next: (response: any) => {
          this.saveData().subscribe(id => {
          });
          this.draftDirectRFQQuoteData();
        },
        complete: () => {
          this.showPageDataLoading = false;
        }
      });
    }
  }

  draftDirectRFQQuoteData() {
    const payload = {
      CompanyId: parseInt(this.queryParams.companyId.toString()),
      SupplierId: parseInt(this.queryParams.companyId.toString()),
      RfqId: this.rfqData.rfqId,
      QuoteStatus: QuoteStatus.Draft,
      RfqPartsMetaData: JSON.stringify(this.rfqData),
      CreatedOn: new Date().toISOString(),
      Source: this.queryParams.integration
    };
    this.directQuoteAssistService.saveDraft(payload).subscribe({
      next: (response: number) => {
        console.log('Draft saved successfully with ID:', response);
      },
      error: (error) => {
        console.error('Error saving draft:', error);
      }
    });
  }
  startQuoteAssist() {
    if (Number(this.inputQty) <= 0) {
      this.toastrService.error("Quantity must be greater than 0.");
      return;
    }
    if (this.currentPart.partName.trim() == '') {
      this.partNameError = true;
      return;
    }
    this.rfqData.isPartAdded = true;
    this.currentPart.quoteAssistData.assistedQty = Number(this.inputQty);
    this.rfqData.rfqPartList[0].qty1 = Number(this.inputQty);
    if(this.rfqData.rfqPartList[0].partQuantity.length > 0){
      this.rfqData.rfqPartList[0].partQuantity[0].qty = Number(this.inputQty);
    }
    this.currentPart.isPartNameFilled = true;
    this.showPageDataLoading = true;
    if(this.currentPartQty){
      this.currentPartQty.qty = this.currentPart.quoteAssistData.assistedQty;
    }
    if (this.currentPart.quoteAssistData.quoteModelLoaded) {
      this.getPartForSuggestion();
      this.calculateAllSections();
      this.quoteAssistModel.quantity.isSectionCompleted = true;
      if (this.currentPartQty) {
        this.currentPartQty.summaryData.isCompleted = false;
      }
      this.updateDirectRFQDetails().subscribe({
        next: (response: any) => {
          // this.getQtyForSuggestion(this.currentPart);
          
          this.updateGrandTotal();
          Object.keys(this.currentPart.quoteAssistData.quoteAssistModel).forEach((prop) => {
            if ((this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].isSectionCompleted) {
              (this.currentPart.quoteAssistData.quoteAssistModel as any)[prop].canCalculate = true;
            }
          });

          this.showSection(this.quoteAssistModel.materials);
          this.showPageDataLoading = false;
        },
        error: (error) => {
          console.error('Error updating RFQ details:', error);
          this.toastrService.error("Failed to update RFQ details.");
        },
        complete: () => {
          this.showPageDataLoading = false;
        }
      });
    } else {
      this.quoteAssistModel.quantity.isSectionCompleted = true;
      this.updateDirectRFQDetails().subscribe({
        next: (response: any) => {
          this.fetchMetaDataFromAPI();
          this.showSection(this.quoteAssistModel.quantity, true);
        },
        error: (error) => {
          console.error('Error updating RFQ details:', error);
          this.toastrService.error("Failed to update RFQ details.");
        }
      });
    }
    //Update IndexedDB
    this.saveData().subscribe(id => {
    });
    //Update DynamoDB
    this.draftDirectRFQQuoteData();
  }

  cancelQuoteDetail() {
    if (!this.rfqData.rfqId) {
      this.rfqData.rfqName = '';
      this.rfqData.quoteNumber = '';
      this.rfqData.quoteDate = this.today.toString();
      this.rfqData.quoteExpiryDate = '';
      this.rfqData.paymentTerm = '';
      this.rfqData.billTo.companyName = '';
      this.rfqData.billTo.address = '';
      this.rfqData.billTo.city = '';
      this.rfqData.billTo.state = '';
      this.rfqData.billTo.zipCode = '';
      this.rfqData.billTo.companyEmail = '';
      this.rfqData.billTo.companyPhoneNumber = '';
    }
    else {
      this.rfqData.billTo = { ...this.originalQuoteDetails };
      this.rfqData.quoteNumber = this.originalQuoteDetails.quoteNumber;
      this.rfqData.quoteDate = this.originalQuoteDetails.quoteDate;
      this.rfqData.quoteExpiryDate = this.originalQuoteDetails.quoteExpiryDate;
      this.rfqData.paymentTerm = this.originalQuoteDetails.paymentTerm;

      this.rfqData.isQuoteDetailEditable = false;
    }
  }
  editQuoteDetail() {
    this.rfqData.isQuoteDetailEditable = true;
    this.clearValidationErrors();
  }

  showConfirmationSection() {
    this.rfqData.isQuoteDetailVisible = false;
    this.rfqData.isAssistSectionVisible = false;
    this.rfqData.isQuoteConfirmationVisible = true;
    this.saveData(true).subscribe(id => {
      this.navigateToSummaryPage();
    });
  }

  getBuyerDetails() {
    this.directQuoteAssistService.getBuyerDetails(this.rfqData.rfqId, this.queryParams.companyId).subscribe({
      next: (response: any) => {
        console.log(response);
      }
    });
  }

  downloadFile(file: any) {
    if (file?.fileUrl) {
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = file.fileUrl;
      link.download = file.fileName;
      link.target = '_blank';
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  /**
   * Sets the RFQ name to edit mode and focuses the input field
   */
  editRfqName() {
    if (this.rfqNameInput) {
      this.rfqNameInput.nativeElement.focus();
      // Update the shared RFQ name
      this.rfqNameService.updateRfqName(this.rfqData.rfqName);
    }
  }

  /**
   * Handles the blur event for the RFQ name input
   * Exits edit mode if the name is not empty
   */
  onRfqNameBlur() {
    if (!this.rfqData.rfqName || !this.rfqData.rfqName.trim()) {
      this.validationErrors.rfqName = true;
      if (this.rfqNameInput) {
        this.rfqNameInput.nativeElement.focus();
      }
      return;
    }
    
    this.clearRfqNameError();
    // Update the shared RFQ name
    this.rfqNameService.updateRfqName(this.rfqData.rfqName);
    // Make the input lose focus
    if (this.rfqNameInput) {
      this.rfqNameInput.nativeElement.blur();
    }
  }

  // Add a new function to clear validation errors
  clearValidationErrors() {
    Object.keys(this.validationErrors).forEach(key => {
      this.validationErrors[key as keyof typeof this.validationErrors] = false;
    });
  }

  // Add methods to clear validation errors on input
  clearRfqNameError() {
    if (this.rfqData.rfqName?.trim()) {
      this.validationErrors.rfqName = false;
    }
  }

  clearQuoteNumberError() {
    if (this.rfqData.quoteNumber?.trim()) {
      this.validationErrors.quoteNumber = false;
    }
  }

  clearQuoteDateError() {
    if (this.rfqData.quoteDate) {
      this.validationErrors.quoteDate = false;
    }
  }

  clearQuoteExpiryDateError() {
    if (this.rfqData.quoteExpiryDate) {
      this.validationErrors.quoteExpiryDate = false;
    }
  }

  clearPaymentTermError() {
    if (this.rfqData.paymentTerm) {
      this.validationErrors.paymentTerm = false;
    }
  }

  clearCompanyNameError() {
    if (this.rfqData.billTo.companyName?.trim()) {
      this.validationErrors.companyName = false;
    }
  }

  clearAddressError() {
    if (this.rfqData.billTo.address?.trim()) {
      this.validationErrors.address = false;
    }
  }

  clearCityError() {
    if (this.rfqData.billTo.city?.trim()) {
      this.validationErrors.city = false;
    }
  }

  clearZipCodeError() {
    if (this.rfqData.billTo.zipCode?.trim()) {
      this.validationErrors.zipCode = false;
    }
  }

  clearStateError() {
    if (this.rfqData.billTo.state?.trim()) {
      this.validationErrors.state = false;
    }
  }

  clearCompanyEmailError() {
    if (this.rfqData.billTo.companyEmail?.trim()) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(this.rfqData.billTo.companyEmail)) {
        this.validationErrors.companyEmail = false;
      }
    }
  }

  clearCompanyPhoneNumberError() {
    if (this.rfqData.billTo.companyPhoneNumber?.trim()) {
      // Get only the numeric digits from the formatted phone number
      const numericValue = this.rfqData.billTo.companyPhoneNumber.replace(/\D/g, '');
      if (numericValue.length === 10) {
        this.validationErrors.companyPhoneNumber = false;
      }
    }
  }

  clearPartNameError() {
    if (this.currentPart.partName?.trim()) {
      this.partNameError = false;
    }
  }

  // Add a method to clear the process name error when user inputs something
  clearManufacturingProcessNameError() {
    if (this.isValidString(this.manufacturingBlankSection.processName)) {
      this.manufacturingProcessNameError = false;
    }
  }

  clearManufacturingProcessCycleTimeError() {
    if (this.manufacturingBlankSection.cycleTimePerUnit > 0) {
      this.manufacturingProcessCycleTimeError = false;
    }
  }

  clearManufacturingProcessTotalLaborTimeError() {
    if (this.manufacturingBlankSection.totalLaborTimeInMinutes > 0) {
      this.manufacturingProcessTotalLaborTimeError = false;
    }
  }

  // Add methods to clear AMR error flags
  clearAMRProcessNameError() {
    if (this.isValidString(this.blankAMRSection.processName)) {
      this.amrProcessNameError = false;
    }
  }

  clearAMREstimatedCostError() {
    if (this.parseAndFormat(this.blankAMRSection.estimatedCost) > 0) {
      this.amrEstimatedCostError = false;
    }
  }

  // Add methods to clear overhead error flags
  clearOverheadTitleError() {
    if (this.isValidString(this.blankOverheadSection.overheadTitle)) {
      this.overheadTitleError = false;
    }
  }

  clearOverheadEstimatedCostError() {
    if (this.parseAndFormat(this.blankOverheadSection.estimatedCost) > 0) {
      this.overheadEstimatedCostError = false;
    }
  }

  // Add methods to clear Other Costs error flags
  clearOtherCostsProcessNameError() {
    if (this.isValidString(this.blankOtherSection.processName)) {
      this.otherCostsProcessNameError = false;
    }
  }

  clearOtherCostsEstimatedCostError() {
    if (this.parseAndFormat(this.blankOtherSection.estimatedCost) > 0) {
      this.otherCostsEstimatedCostError = false;
    }
  }

  // Remove the convertInternationalToDecimal method since it's now in the service
  // ... existing code ...

  onRfqNameFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    if (!input.value.trim()) {
      input.value = 'Enter RFQ Name';
      input.select();
      this.rfqData.rfqName = 'Enter RFQ Name';
    } else if (input.value === 'Enter RFQ Name') {
      input.select();
    }
  }

  onRfqNameInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Trim leading spaces and update the input value
    const trimmedValue = input.value.replace(/^\s+/, '');
    if (trimmedValue !== input.value) {
      input.value = trimmedValue;
      this.rfqData.rfqName = trimmedValue;
    }
    
    if (!trimmedValue) {
      this.validationErrors.rfqName = true;
      this.rfqNameInput.nativeElement.focus();
      return;
    }
    
    this.clearRfqNameError();
  }

}